var YC_CHECKOUT = (function () {
function norm(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, " ").trim(); }
var DEPTOS = {
"amazonas": "AMA", "antioquia": "ANT", "arauca": "ARA", "atlantico": "ATL", "bolivar": "BOL", "boyaca": "BOY", "caldas": "CAL",
"caqueta": "CAQ", "casanare": "CAS", "cauca": "CAU", "cesar": "CES", "choco": "CHO", "cordoba": "COR", "cundinamarca": "CUN",
"guainia": "GUA", "guaviare": "GUV", "huila": "HUI", "la guajira": "LAG", "magdalena": "MAG", "meta": "MET", "narino": "NAR",
"norte de santander": "NSA", "putumayo": "PUT", "quindio": "QUI", "risaralda": "RIS", "santander": "SAN", "sucre": "SUC",
"tolima": "TOL", "valle del cauca": "VAC", "vaupes": "VAU", "vichada": "VID",
"san andres y providencia": "SAP", "san andres providencia y santa catalina": "SAP", "archipielago de san andres providencia y santa catalina": "SAP"
};
function provincia(region) {
var n = norm(region).replace(/^(departamento|depto|dpto) (del |de la |de )?/, "");
if (!n) return "";
if (/bogota|distrito capital|^d c$/.test(n)) return "DC";
if (DEPTOS[n]) return DEPTOS[n];
if (n === "valle") return "VAC";
if (n === "guajira") return "LAG";
if (n === "san andres") return "SAP";
return "";
}
function direccion(est) {
est = est || {};
var ciudad = "", prov = "";
if (est.tipo === "bogota") { ciudad = "Bogotá"; prov = "DC"; }
else if (est.tipo === "soacha") { ciudad = "Soacha"; prov = "CUN"; }
else if (est.tipo === "otra") { ciudad = String(est.ciudad || "").trim(); prov = ciudad ? provincia(est.region) : ""; if (/^bogot/.test(norm(ciudad)) || norm(ciudad) === "soacha") ciudad = ""; }
if (!ciudad || ciudad.length > 60 || /[<>\\]|^\d/.test(ciudad)) return null;
var d = { country: "Colombia", city: ciudad };
if (prov) d.province = prov;
return d;
}
function url(raizTienda, est, codigo) {
var u = (raizTienda || "/") + "checkout", d = direccion(est), q = [];
if (codigo && /^[A-Za-z0-9_-]{1,40}$/.test(String(codigo))) q.push("discount=" + codigo);
if (d) ["country", "city", "province"].forEach(function (k) { if (d[k]) q.push("checkout[shipping_address][" + k + "]=" + encodeURIComponent(d[k])); });
return q.length ? u + "?" + q.join("&") : u;
}
return { url: url, direccion: direccion, provincia: provincia, DEPTOS: DEPTOS };
})();
if (typeof module !== "undefined" && module.exports) module.exports = YC_CHECKOUT;
(function () {
"use strict";
var raiz = document.querySelector("[data-yc-raiz]");
if (!raiz || raiz.__yc) return;
raiz.__yc = true;
var CFG = window.YC_CONFIG || {};
var TIENDA = CFG.tienda || {};
var BASE = window.YC_BASE || "assets/";
var COD = TIENDA.cod || ((CFG.releasit || {}).activo === false ? "checkout" : "releasit");
var DATOS = {};
try { DATOS = JSON.parse(document.getElementById("yc-datos").textContent); } catch (e) { DATOS = {}; }
var VARS = DATOS.variantes || [], FOTOS = DATOS.fotos || [];
function bonito(c) { var x = cfgColor(c); c = String(c == null ? "" : c); return x ? x.nombre : c.charAt(0).toUpperCase() + c.slice(1).toLowerCase(); }
VARS.forEach(function (v) { v.c = bonito(v.c); });
var QA = /[?&]qa\b/.test(location.search);
var $ = function (s, r) { return (r || raiz).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || raiz).querySelectorAll(s)); };
var reducido = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
var comp = reducido ? "auto" : "smooth";
var hayIO = "IntersectionObserver" in window;
var YC = window.YC = window.YC || {};
function leerSes(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
function guardarSes(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
function reanimar(el, c) {
if (!el.classList.contains(c)) { el.classList.add(c); return; }
el.classList.remove(c); requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add(c); }); });
}
function txt(e, s) { var f = e.firstChild; s = String(s); if (s && f && f.nodeType === 3 && !f.nextSibling) { if (f.data !== s) f.data = s; } else if (e.textContent !== s) e.textContent = s; }
function html(e, s) { if (e.__ycH !== s) { e.__ycH = s; e.innerHTML = s; } }
function ocultar(e, si) { si = !!si; if (e.hidden !== si) e.hidden = si; }
function atr(e, k, v) { if (e.getAttribute(k) !== v) e.setAttribute(k, v); }
var cacheQ = {};
function Q(s) { return cacheQ[s] || (cacheQ[s] = $$(s)); }
function olvidar() { cacheQ = {}; }
var pend = {}, pendOrden = [], pendT = 0;
function vaciar() {
clearTimeout(pendT); pendT = 0; var o = pendOrden, p = pend; pendOrden = []; pend = {};
o.forEach(function (k) { try { p[k](); } catch (e) { if (window.console) console.error("yc", e); } });
}
function luego(k, fn) {
if (!pend[k]) pendOrden.push(k); pend[k] = fn;
if (!pendT) { pendT = setTimeout(vaciar, 300); requestAnimationFrame(function () { setTimeout(function () { if (pendT) vaciar(); }, 0); }); }
}
YC.vaciar = vaciar;
function abrirTras(btn, fn) {
var b = btn && btn.classList ? btn : null; if (b) b.classList.add("is-toque");
luego("abrir", function () { if (b) b.classList.remove("is-toque"); fn(); });
}
var ocio = window.requestIdleCallback ? function (fn) { requestIdleCallback(fn, { timeout: 2500 }); } : function (fn) { setTimeout(fn, 1200); };
function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;"); }
function norm(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, " ").trim(); }
function porFrame(fn) { var p = false; return function () { if (p) return; p = true; requestAnimationFrame(function () { p = false; fn(); }); }; }
function ico(n, c) { return '<svg class="yc-i' + (c ? " " + c : "") + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="#yc-g-' + n + '"></use></svg>'; }
function pad(n) { return String(n).padStart(2, "0"); }
YC.eventos = [];
function track(ev) { YC.eventos.push(ev); try { if (window.clarity) window.clarity("event", ev); } catch (e) {} }
function marcarDato(k, v) { try { if (window.clarity) window.clarity("set", k, String(v)); } catch (e) {} }
YC.track = track;
var qaClarity = typeof window.YC_QA_CLARITY === "function" ? window.YC_QA_CLARITY : null;
YC.clarity = CFG.clarityId ? "local" : "sin-id";
if (CFG.clarityId && (qaClarity || !/^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname))) {
window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
YC.clarity = "espera";
var GESTOS = ["pointerdown", "keydown", "scroll", "touchstart"], clarityT = 0;
var cargarClarity = function () {
if (YC.clarity === "pedido") return; YC.clarity = "pedido";
var u = "https://www.clarity.ms/tag/" + encodeURIComponent(CFG.clarityId);
if (qaClarity) { qaClarity(u); return; }
var s = document.createElement("script"); s.async = true; s.src = u; document.head.appendChild(s);
};
var pedirClarity = function () {
if (YC.clarity !== "espera") return; YC.clarity = "listo";
clearTimeout(clarityT); GESTOS.forEach(function (ev) { document.removeEventListener(ev, pedirClarity, true); });
ocio(cargarClarity);
};
GESTOS.forEach(function (ev) { document.addEventListener(ev, pedirClarity, { passive: true, capture: true }); });
var trasCarga = function () { clarityT = setTimeout(pedirClarity, 3000); };
if (document.readyState === "complete") trasCarga(); else window.addEventListener("load", trasCarga);
marcarDato("pagina", "blusa-corset");
}
var toastT;
function aviso(html, ms) {
var t = $("[data-yc-toast]"); if (!t) return;
t.innerHTML = html; t.classList.add("is-on");
clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove("is-on"); }, ms || 3600);
}
function num(x) { return String(Math.round(x)).replace(/\B(?=(\d{3})+(?!\d))/g, "."); }
function fmt(x) { return "$" + num(x); }
var colores = [], tallas = [], porColor = {};
VARS.forEach(function (v) {
if (colores.indexOf(v.c) < 0) colores.push(v.c);
if (tallas.indexOf(v.t) < 0) tallas.push(v.t);
});
if (tallas.every(function (t) { return !isNaN(+t); })) tallas.sort(function (a, b) { return a - b; });
function cfgColor(c) { var k = norm(c); return (CFG.colores || []).filter(function (x) { return norm(x.nombre) === k; })[0] || null; }
function variante(c, t) { for (var i = 0; i < VARS.length; i++) if (VARS[i].c === c && VARS[i].t === t) return VARS[i]; return null; }
function hayStock(c, t) { var v = variante(c, t); return !!(v && v.d); }
function colorConStock(c) { return tallas.some(function (t) { return hayStock(c, t); }); }
var fotoPorId = {};
FOTOS.forEach(function (f) { fotoPorId[String(f.id)] = f; });
function fotosDe(c) {
if (porColor[c]) return porColor[c];
var x = cfgColor(c), bus = "blusa corset " + norm(c), l = FOTOS.filter(function (f) { return (" " + norm(f.a) + " ").indexOf(" " + bus + " ") > -1; });
if (l.length) { var vis = function (f) { var m = /vista\s+(\d+)/i.exec(f.a || ""); return m ? +m[1] : 1; }; l = l.map(function (f, i) { return { f: f, i: i }; }).sort(function (p, q) { return (vis(p.f) - vis(q.f)) || (p.i - q.i); }).map(function (p) { return p.f; }); }
if (!l.length && x) (x.fotos || []).forEach(function (id) { if (fotoPorId[id]) l.push(fotoPorId[id]); });
if (!l.length) VARS.forEach(function (v) { if (v.c === c && v.f && fotoPorId[String(v.f)] && l.indexOf(fotoPorId[String(v.f)]) < 0) l.push(fotoPorId[String(v.f)]); });
if (!l.length) l = FOTOS.slice();
return (porColor[c] = l);
}
function url(f, w) { return String(f.u).replace(/{w}|YCW/, w); }
var ANCHOS = [540, 720, 1080];
function srcset(f) { return ANCHOS.map(function (w) { return url(f, w) + " " + w + "w"; }).join(", "); }
function alt(f, c) {
if (f.a) return f.a;
var p = (CFG.planos || {})[f.id];
return "Blusa Corset " + c + " de Yass Moda" + (p ? ", " + p : "");
}
function tex(c) { var x = cfgColor(c); if (x) return BASE + "yc-tex-" + x.clave + ".webp"; var f = fotosDe(c)[0]; return f ? url(f, 180) : ""; }
YC.fotosDe = fotosDe; YC.url = url;
var P = CFG.precios || {};
var qv = /[?&]variant=(\d+)/.exec(location.search), vIni = null, pista0 = raiz.querySelector("[data-yc-gal-pista]");
if (qv) VARS.forEach(function (v) { if (String(v.id) === qv[1]) vIni = v; });
if (!vIni) { var ssr = raiz.getAttribute("data-yc-variante"); if (pista0 && pista0.getAttribute("data-yc-color")) pista0.setAttribute("data-yc-color", bonito(pista0.getAttribute("data-yc-color"))); VARS.forEach(function (v) { if (String(v.id) === ssr) vIni = v; }); }
if (!vIni) vIni = VARS.filter(function (v) { return v.d && v.c === CFG.colorInicial; })[0] || VARS.filter(function (v) { return v.d; })[0] || VARS[0] || { c: "", t: "" };
var est = { n: 1, unis: [{ c: vIni.c, t: qv && vIni.d ? vIni.t : null }], regaloTalla: null, regaloManual: false };
function ajustarUnis() {
while (est.unis.length < est.n) { var u = est.unis[est.unis.length - 1]; est.unis.push({ c: u.c, t: null }); }
est.unis.length = est.n;
}
YC.estado = est;
YC.agotar = function (c, t) { var v = variante(c, t); if (v) v.d = false; est.unis.forEach(function (u) { if (u.t && !hayStock(u.c, u.t)) u.t = null; }); pintarSeleccion(); };
var pista = $("[data-yc-gal-pista]"), minis = $("[data-yc-gal-minis]"), galAct = 0;
var SIZES = "(min-width:1240px) 620px, (min-width:900px) 52vw, (max-width:479px) 180px, 60vw";
function htmlGaleria(c) {
var l = fotosDe(c), s = "", m = "";
l.forEach(function (f, i) {
s += '<figure class="yc-gal__slide" aria-roledescription="diapositiva" aria-label="' + (i + 1) + " de " + l.length + '"><img src="' + esc(url(f, 720)) + '" srcset="' + esc(srcset(f)) + '" sizes="' + SIZES + '" width="' + f.w + '" height="' + f.h + '" alt="' + esc(alt(f, c)) + '"' + (i ? ' loading="lazy"' : ' fetchpriority="high"') + ' decoding="async" draggable="false"></figure>';
m += '<button type="button" class="yc-gal__mini" data-yc-mini="' + i + '" aria-label="Ver foto ' + (i + 1) + '"' + (i ? "" : ' aria-current="true"') + '><img src="' + esc(url(f, 180)) + '" width="52" height="65" alt=""' + (i > 5 ? ' loading="lazy"' : "") + ' decoding="async"></button>';
});
return { s: s, m: m, n: l.length };
}
var cacheGal = {};
function pintarGaleria(c) {
if (!pista) return;
if (pista.getAttribute("data-yc-color") === c && pista.children.length) return;
if (!cacheGal[c]) cacheGal[c] = htmlGaleria(c);
var h = cacheGal[c];
pista.innerHTML = h.s; minis.innerHTML = h.m;
pista.setAttribute("data-yc-color", c);
pista.scrollLeft = 0; galAct = -1; marcarGal(0);
Q("[data-yc-gal-total]").forEach(function (e) { txt(e, h.n); });
}
function slides() { return $$(".yc-gal__slide", pista); }
function marcarGal(i) {
if (i === galAct) return; galAct = i;
var n = Q("[data-yc-gal-n]")[0]; if (n) txt(n, i + 1);
$$("[data-yc-mini]", minis).forEach(function (m, k) { if (k === i) { m.setAttribute("aria-current", "true"); if (!QA) { var r = m.parentNode; r.scrollTo({ left: m.offsetLeft - r.clientWidth / 2 + m.offsetWidth / 2, top: m.offsetTop - r.clientHeight / 2, behavior: comp }); } } else m.removeAttribute("aria-current"); });
}
function irGal(i, suave) { var l = slides().length; if (!l) return; i = (i + l) % l; pista.scrollTo({ left: i * pista.clientWidth, behavior: suave ? comp : "auto" }); marcarGal(i); }
function arrastrar(p, alSoltar) {
var x0 = null, s0 = 0, movio = false;
p.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse" || e.button !== 0) return; x0 = e.clientX; s0 = p.scrollLeft; movio = false; });
window.addEventListener("pointermove", function (e) {
if (x0 === null) return; var dx = e.clientX - x0; if (!movio && Math.abs(dx) < 6) return;
if (!movio) { movio = true; p.classList.add("is-arrastre"); } p.scrollLeft = s0 - dx;
});
window.addEventListener("pointerup", function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (!movio) return; p.classList.remove("is-arrastre"); alSoltar(dx); });
p.addEventListener("click", function (e) { if (movio) { e.preventDefault(); e.stopPropagation(); movio = false; } }, true);
p.addEventListener("dragstart", function (e) { e.preventDefault(); });
}
if (pista) {
pista.addEventListener("scroll", porFrame(function () { marcarGal(Math.round(pista.scrollLeft / pista.clientWidth)); }), { passive: true });
var g0 = 0; pista.addEventListener("pointerdown", function () { g0 = galAct; });
arrastrar(pista, function (dx) { var i = Math.round(pista.scrollLeft / pista.clientWidth); if (i === g0 && Math.abs(dx) > 40) i += dx < 0 ? 1 : -1; irGal(i, true); });
pista.addEventListener("keydown", function (e) { if (e.key === "ArrowRight") { e.preventDefault(); irGal(galAct + 1, true); } else if (e.key === "ArrowLeft") { e.preventDefault(); irGal(galAct - 1, true); } });
minis.addEventListener("click", function (e) { var m = e.target.closest("[data-yc-mini]"); if (m) irGal(+m.getAttribute("data-yc-mini"), true); });
$("[data-yc-gal-prev]").addEventListener("click", function () { irGal(galAct - 1, true); });
$("[data-yc-gal-next]").addEventListener("click", function () { irGal(galAct + 1, true); });
window.addEventListener("resize", porFrame(function () { pista.scrollLeft = galAct * pista.clientWidth; }));
}
function verGaleria() {
var g = $(".yc-gal__main"); if (!g) return false;
var r = g.getBoundingClientRect(), alto = Math.max(1, r.height), vis = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
if (vis >= alto * 0.6) return false;
g.scrollIntoView({ behavior: comp, block: "start" });
return true;
}
YC.verGaleria = verGaleria;
function htmlColores() {
return colores.map(function (c) {
return '<button type="button" role="radio" class="yc-color' + (colorConStock(c) ? "" : " is-agotado") + '" data-yc-color="' + esc(c) + '" aria-checked="false" aria-label="' + esc(c) + (colorConStock(c) ? "" : " (agotado)") + '"><span class="yc-color__c" style="background-image:url(' + esc(tex(c)) + ')"></span><span class="yc-color__n">' + esc(c) + "</span></button>";
}).join("");
}
function marcarRadios(caja, atrib, valor) {
if (!caja) return; var l = caja.querySelectorAll("[" + atrib + "]");
for (var i = 0; i < l.length; i++) atr(l[i], "aria-checked", l[i].getAttribute(atrib) === String(valor) ? "true" : "false");
}
var boxColores = $("[data-yc-colores]"), boxPaq = $("[data-yc-paq]"), ctaMain = $(".yc-accion [data-yc-comprar]");
var tieneHover = !!(window.matchMedia && matchMedia("(hover:hover)").matches);
if (boxColores && colores.length) {
var ssrC = boxColores.querySelectorAll("[data-yc-color]"), igual = ssrC.length === colores.length;
for (var ic = 0; igual && ic < ssrC.length; ic++) if (ssrC[ic].getAttribute("data-yc-color") !== colores[ic]) igual = false;
if (!igual) boxColores.innerHTML = htmlColores();
else for (ic = 0; ic < ssrC.length; ic++) { var okC = colorConStock(colores[ic]); ssrC[ic].classList.toggle("is-agotado", !okC); atr(ssrC[ic], "aria-label", colores[ic] + (okC ? "" : " (agotado)")); }
}
var difOk = false;
function soltarDiferidas() {
if (difOk) return; difOk = true; setTimeout(preArmar, 0);
var l = raiz.querySelectorAll("img[data-yc-dif]");
for (var i = 0; i < l.length; i++) { var s = l[i].getAttribute("data-yc-difset"); if (s) { l[i].setAttribute("srcset", s); l[i].removeAttribute("data-yc-difset"); } l[i].src = l[i].getAttribute("data-yc-dif"); l[i].removeAttribute("data-yc-dif"); }
}
YC.soltarDiferidas = soltarDiferidas;
var preArmado = false;
function preArmar() { if (preArmado) return; preArmado = true; ocio(function () { try { crearDlg(); pintarPop(); pintarPrecios(); } catch (e) {} }); }
(function () {
var h = raiz.querySelector("[data-yc-gal-pista] img");
if (!h || h.complete) { soltarDiferidas(); return; }
h.addEventListener("load", soltarDiferidas); h.addEventListener("error", soltarDiferidas);
setTimeout(soltarDiferidas, 6000);
["scroll", "pointerdown", "keydown", "touchstart"].forEach(function (ev) { document.addEventListener(ev, soltarDiferidas, { passive: true, capture: true, once: true }); });
})();
function u0() { return est.unis[0]; }
var boxTallas = $("[data-yc-tallas]"), campoTalla = $("[data-yc-tal]"), accion = $(".yc-accion"), btnsTalla = boxTallas ? boxTallas.querySelectorAll("[data-yc-talla]") : [];
function pintarTallas() {
var u = u0();
for (var k = 0; k < btnsTalla.length; k++) {
var b = btnsTalla[k], t = b.getAttribute("data-yc-talla"), ok = hayStock(u.c, t);
b.classList.toggle("is-agotada", !ok); atr(b, "aria-disabled", ok ? "false" : "true");
atr(b, "aria-label", "Talla " + t + (ok ? "" : ", agotada")); atr(b, "aria-checked", u.t === t ? "true" : "false");
}
if (u.t && campoTalla) campoTalla.classList.remove("is-falta");
}
function pintarRapido() {
marcarRadios(boxColores, "data-yc-color", u0().c);
pintarTallas();
pintarPop(true);
}
var urlVar = null;
function pintarSeleccion() {
var u = u0(), c = u.c, t = u.t, x = cfgColor(c);
marcarRadios(boxColores, "data-yc-color", c); pintarTallas();
Q("[data-yc-color-txt]").forEach(function (e) { txt(e, c); });
Q("[data-yc-color-tono]").forEach(function (e) { txt(e, x && x.tono ? "· " + x.tono : ""); });
pintarPop();
pintarTex();
pintarGaleria(c);
var v = t ? variante(c, t) : null;
if (v && v.d && urlVar !== v.id) { urlVar = v.id; try { var q = new URLSearchParams(location.search); q.set("variant", v.id); history.replaceState(history.state, "", location.pathname + "?" + q.toString() + location.hash); } catch (e) {} }
pintarPrecios(); pintarDinamicos(); rovingTodo();
}
function pintarTex() { var c = u0().c, u = null; Q("[data-yc-gal-tex]").forEach(function (e) { if (e.__ycC !== c) { e.__ycC = c; e.style.backgroundImage = u || (u = "url(" + tex(c) + ")"); } }); }
function elegirColor(c, i, deUsuaria, origen) {
i = i || 0; var u = est.unis[i]; if (!u) return;
u.c = c; if (u.t && !hayStock(c, u.t)) u.t = null;
if (!deUsuaria) { pintarSeleccion(); return; }
pintarRapido();
luego("sel", function () { pintarSeleccion(); if (origen !== "pop" && i === 0) { verGaleria(); tocoSelector(); } });
track("color_elegido"); if (origen === "pop") track("popup_color"); if (i === 0) marcarDato("color", c);
}
function elegirTalla(t, i, deUsuaria, origen) {
i = i || 0; var u = est.unis[i]; if (!u || !hayStock(u.c, t)) return; u.t = t;
if (!deUsuaria) { pintarSeleccion(); return; }
if (origen === "pop") { track("popup_talla"); track("popup_unidad_lista"); }
pintarRapido();
luego("sel", function () { pintarSeleccion(); if (origen === "pop") trasTallaPop(i); else if (i === 0) tocoSelector(); });
track("talla_elegida"); if (i === 0) marcarDato("talla", t);
}
YC.elegirColor = elegirColor; YC.elegirTalla = elegirTalla;
function precioBase() { var v = variante(u0().c, u0().t) || vIni; return v && v.p ? v.p / 100 : P[1]; }
function comparar() { var v = variante(u0().c, u0().t) || vIni; return v && v.cp ? v.cp / 100 : 0; }
var DFIJO = CFG.descuentosFijos || null;
function rebaja(n) { var x = 0; if (DFIJO) Object.keys(DFIJO).forEach(function (k) { if (n >= +k) x = +DFIJO[k]; }); return x; }
function total(n) { if (n === 1) return precioBase(); if (DFIJO) return Math.max(0, precioBase() * n - rebaja(n)); return P[n] || precioBase() * n; }
YC.total = total;
function resumen() { return est.unis.map(function (u) { return u.c + (u.t ? " " + u.t : ""); }).join(" + "); }
function pintarPrecios() {
var n = est.n, tot = total(n), cp = comparar() * n, uni = tot / n, ahorroPaq = precioBase() * n - tot;
Q("[data-yc-precio]").forEach(function (e) { txt(e, fmt(tot)); });
Q("[data-yc-antes]").forEach(function (e) { txt(e, cp > tot ? fmt(cp) : ""); ocultar(e, !(cp > tot)); });
Q("[data-yc-ahorro]").forEach(function (e) { txt(e, cp > tot ? "Ahorras " + fmt(cp - tot) : ""); ocultar(e, !(cp > tot)); });
Q("[data-yc-unitario]").forEach(function (e) { html(e, n > 1 ? "<b>" + fmt(uni) + " c/u</b> · " + fmt(ahorroPaq) + " menos por llevar " + n : ""); });
[1, 2, 3].forEach(function (k) {
var tk = total(k), ak = precioBase() * k - tk;
Q('[data-yc-of-total="' + k + '"]').forEach(function (e) { txt(e, fmt(tk)); });
Q('[data-yc-of-ahorro="' + k + '"]').forEach(function (e) { txt(e, ak > 0 ? "Ahorras " + fmt(ak) : ""); });
Q('[data-yc-of-uni="' + k + '"]').forEach(function (e) { txt(e, k > 1 ? fmt(tk / k) + " c/u" : "Precio normal"); });
});
marcarRadios(boxPaq, "data-yc-n", n);
pintarCta();
Q("[data-yc-barra-precio]").forEach(function (e) { txt(e, fmt(tot)); });
Q("[data-yc-barra-nom]").forEach(function (e) { txt(e, n === 1 ? "1 Blusa Corset" : n + " Blusas Corset"); });
var u = u0(), det = n > 1 ? "Eliges color y talla de cada una" : u.c + (u.t ? " · Talla " + u.t : " · elige tu talla");
Q("[data-yc-barra-det]").forEach(function (e) { txt(e, det); e.classList.toggle("is-lista", n === 1 && !!u.t); });
pintarAccion();
Q("[data-yc-fin-sel]").forEach(function (e) { txt(e, (n === 1 ? "1 Blusa Corset" : n + " Blusas Corset") + " · " + fmt(tot)); });
pintarRegalos(); pintarEnvio();
}
var ANT = CFG.anticipado && CFG.anticipado.activo && CFG.anticipado.codigo && +CFG.anticipado.pct > 0 ? CFG.anticipado : null;
function hayAnticipado() { return !!(ANT && tipoCiudad && (ANT.ciudades || []).indexOf(tipoCiudad) > -1 && esContraEntrega()); }
function totalAnticipado(n) { var t = total(n || est.n); return Math.round(t * (100 - ANT.pct) / 100); }
YC.hayAnticipado = hayAnticipado; YC.totalAnticipado = function (n) { return ANT ? totalAnticipado(n) : null; };
function regalosTxt(n, corto) { return regalosDe(n).map(function (r) { return esc(corto ? r.mini || r.corto || r.nombre : r.corto || r.nombre); }).join(" + "); }
function pintarEnvio() {
var ce = esContraEntrega(), tarifa = fmt((EXP && EXP.tarifa) || 10000);
if (dlgModo !== "carrito") {
Q("[data-yc-dlg-total]").forEach(function (e) { txt(e, fmt(total(est.n))); });
var rot = GRATIS ? "Total <small>· envío gratis</small>" : ce ? "Total <small>+ envío express " + tarifa + "</small>" : tipoCiudad ? "Total <small>· el envío lo pagas al recibir</small>" : "Total <small>+ envío</small>";
Q("[data-yc-dlg-tot-t]").forEach(function (e) { html(e, rot); });
Q("[data-yc-dlg-va]").forEach(function (e) { html(e, "Va con tu compra: <b>" + regalosTxt(est.n) + "</b>"); });
if (ANT) { var ta = totalAnticipado(); Q("[data-yc-ant-det]").forEach(function (e) { txt(e, fmt(ta) + " · ahorras " + fmt(total(est.n) - ta)); }); }
}
Q("[data-yc-ciu-nota]").forEach(function (e) { html(e, notaCiudad()); });
Q("[data-yc-entrega-via]").forEach(function (e) { txt(e, GRATIS ? "· envío gratis" : ce ? "· express " + tarifa : "· con Interrapidísimo"); });
pintarExpress();
}
function pintarCta() {}
function pintarAccion() {
var v = est.n > 1;
if (accion) { accion.classList.toggle("is-varias", v); accion.classList.toggle("is-ant1", !v && hayAnticipado()); accion.classList.toggle("is-n2", est.n === 2); accion.classList.toggle("is-n3", est.n >= 3); }
if (campoTalla) campoTalla.classList.toggle("is-varias", v);
var campoColor = boxColores && boxColores.closest ? boxColores.closest(".yc-verc") : null; if (campoColor) campoColor.classList.toggle("is-varias", v);
}
var popFilas = null;
function sigSinTalla(desde) {
for (var k = 1; k <= est.n; k++) { var j = ((desde || 0) + k) % est.n; if (!est.unis[j].t) return j; }
return -1;
}
function htmlUnis() {
return [0, 1, 2].map(function (i) {
var cs = colores.map(function (c) { return '<button type="button" role="radio" class="yc-uni__c' + (colorConStock(c) ? "" : " is-agotado") + '" data-yc-u="' + i + '" data-yc-uc="' + esc(c) + '" aria-checked="false" aria-label="' + esc(c) + '" title="' + esc(c) + '" style="background-image:url(' + esc(tex(c)) + ')"></button>'; }).join("");
var ts = tallas.map(function (t) { return '<button type="button" role="radio" class="yc-uni__tl" data-yc-u="' + i + '" data-yc-ut="' + esc(t) + '" aria-checked="false" aria-label="Talla ' + esc(t) + '">' + esc(t) + "<small>Agotada</small></button>"; }).join("");
return '<div class="yc-uni" data-yc-uni="' + i + '">'
+ '<p class="yc-uni__t"><b>' + (i ? "Blusa " + (i + 1) : '<span class="yc-uni__una">Tu blusa</span><span class="yc-uni__var">Blusa 1</span>') + '</b><span class="yc-uni__av">Falta la talla</span></p>'
+ '<div class="yc-uni__cs" role="radiogroup" aria-label="Color de la blusa ' + (i + 1) + '">' + cs + "</div>"
+ '<div class="yc-uni__ts" role="radiogroup" aria-label="Talla de la blusa ' + (i + 1) + '">' + ts + "</div></div>";
}).join("");
}
function regaloSeguir() {
var g = regaloPrenda(est.n); if (!g) return null;
var t1 = null; for (var ir = 0; ir < est.unis.length && !t1; ir++) if (est.unis[ir].t) t1 = est.unis[ir].t;
if (g.tallas.length === 1) est.regaloTalla = g.tallas[0];
else est.regaloTalla = t1 && g.tallas.indexOf(t1) > -1 ? t1 : null;
return g;
}
function htmlRegaloTalla() {
var g = REG.filter(function (r) { return r.tallas && r.tallas.length; })[0]; if (!g) return "";
var nom = "Talla de tu " + esc((g.prenda || "prenda").toLowerCase()) + " de regalo";
return '<p class="yc-regt yc-regt--auto is-fuera" data-yc-regt>' + ico("regalo") + '<span data-yc-regt-auto></span></p>';
}
function pintarRegaloTalla() {
var box = dlg && dlg.__ycRegt; if (!box) return;
var g = regaloSeguir(); box.classList.toggle("is-fuera", !g || dlgModo === "carrito"); if (!g) return;
var sp = box.__ycS || (box.__ycS = box.querySelector("[data-yc-regt-auto]")), pr = String(g.prenda || "prenda").toLowerCase();
if (sp) html(sp, est.regaloTalla ? "Tu " + esc(pr) + " de regalo va en talla <b>" + esc(est.regaloTalla) + "</b>, la misma de tu blusa." : "Tu " + esc(pr) + " de regalo va en la misma talla de tu blusa.");
}
function pintarPop() {
if (!dlg || !popFilas) return;
var n = est.n, caja = popFilas[0].parentNode;
caja.classList.toggle("is-una", n === 1);
popFilas.forEach(function (f, i) {
var u = est.unis[i]; f.classList.toggle("is-fuera", !u); if (!u) return;
var lista = !!u.t && hayStock(u.c, u.t);
f.classList.toggle("is-lista", lista);
if (lista) f.classList.remove("is-falta");
var b = f.__ycB, k;
for (k = 0; k < b.c.length; k++) atr(b.c[k], "aria-checked", b.c[k].getAttribute("data-yc-uc") === u.c ? "true" : "false");
for (k = 0; k < b.t.length; k++) {
var t = b.t[k].getAttribute("data-yc-ut"), ok = hayStock(u.c, t);
b.t[k].classList.toggle("is-agotada", !ok); atr(b.t[k], "aria-disabled", ok ? "false" : "true");
atr(b.t[k], "aria-label", "Talla " + t + (ok ? "" : ", agotada")); atr(b.t[k], "aria-checked", u.t === t ? "true" : "false");
}
});
pintarRegaloTalla();
}
function trasTallaPop(i) {
if (!dlg || !dlg.open) return;
var j = sigSinTalla(i || 0), f = j >= 0 && popFilas ? popFilas[j] : null;
if (f) { try { f.scrollIntoView({ behavior: comp, block: "nearest" }); } catch (e) {} return; }
rebotar($("[data-yc-finalizar]", dlg));
}
function elegirPaquete(n, origen, calla) {
var antes = est.n; est.n = n; ajustarUnis();
function resto() {
pintarPop(); pintarPrecios(); pintarDinamicos(); rovingTodo();
if (!origen) return;
avisarCta(origen);
if (n > antes && !reducido) Q(".yc-regalo").forEach(function (li) { var d = +li.getAttribute("data-desde"); if (d > antes && d <= n) { reanimar(li, "is-nuevo"); destellos(li); } });
}
if (origen || calla) {
marcarRadios(boxPaq, "data-yc-n", n); pintarAccion(); pintarPop();
luego("paq", resto);
track("oferta_elegida_" + n); if (calla) track("popup_cantidad"); marcarDato("paquete", n);
} else resto();
}
YC.elegirPaquete = elegirPaquete;
function rebotar(x) { if (!x || reducido) return; reanimar(x, "is-rebote"); clearTimeout(x.__ycReb); x.__ycReb = setTimeout(function () { x.classList.remove("is-rebote"); }, 1900); }
function avisarCta(of) {
var b = ctaMain, barra = Q("[data-yc-barra]")[0];
if (!b) return;
var r = b.getBoundingClientRect(), h = window.innerHeight || document.documentElement.clientHeight;
if (of && of.classList && !reducido) reanimar(of, "is-elegida");
rebotar(b); if (barra && barra.classList.contains("is-on")) rebotar($("[data-yc-comprar]", barra));
if (r.bottom > h - 12 || r.top < 0) { var a = b.closest("[data-yc-cta-principal]") || b; try { a.scrollIntoView({ behavior: comp, block: "nearest" }); } catch (e) { a.scrollIntoView(false); } }
}
YC.avisarCta = avisarCta;
var ESTRELLA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 1.5c.6 5.4 3.6 9.4 10.5 10.5-6.9 1.1-9.9 5.1-10.5 10.5-.6-5.4-3.6-9.4-10.5-10.5C8.4 10.9 11.4 6.9 12 1.5z"/></svg>';
var PUNTOS = [[-0.15, -0.2, 10, 0], [0.55, -0.42, 7, 90], [1.12, -0.12, 9, 170], [1.2, 0.72, 6, 260], [0.42, 1.18, 8, 340], [-0.22, 0.8, 6, 430]];
function destellos(li) {
var box = $("[data-yc-fx]"), img = li && li.querySelector(".yc-regalo__img, .yc-med"); if (!box || !img || reducido) return;
var rb = box.getBoundingClientRect(), ri = img.getBoundingClientRect(), f = document.createDocumentFragment();
if (ri.bottom < 0 || ri.top > innerHeight) return;
PUNTOS.forEach(function (p) {
var s = document.createElement("i"); s.className = "yc-estrella"; s.innerHTML = ESTRELLA;
s.style.cssText = "left:" + (ri.left - rb.left + p[0] * ri.width).toFixed(1) + "px;top:" + (ri.top - rb.top + p[1] * ri.height).toFixed(1) + "px;--t:" + p[2] + "px;animation-delay:" + p[3] + "ms";
s.addEventListener("animationend", function () { if (this.parentNode) this.parentNode.removeChild(this); });
f.appendChild(s);
});
box.appendChild(f);
}
YC.destellos = destellos;
var REG = CFG.regalos || [];
function regalosDe(n) { return REG.filter(function (r) { return r.desde <= n; }); }
function regaloPrenda(n) { return regalosDe(n).filter(function (r) { return r.tallas && r.tallas.length; })[0] || null; }
function pintarRegalos() {
var n = est.n, si = regalosDe(n), sig = REG.filter(function (r) { return r.desde > n; })[0];
Q(".yc-regalo").forEach(function (li) { li.classList.toggle("is-si", +li.getAttribute("data-desde") <= n); });
Q("[data-yc-reg-n]").forEach(function (e) { txt(e, si.length); });
var esc_ = "scaleX(" + (REG.length ? si.length / REG.length : 1).toFixed(3) + ")";
Q("[data-yc-reg-fill]").forEach(function (e) { if (e.__ycT !== esc_) { e.__ycT = esc_; e.style.transform = esc_; } });
var l = sig ? "Lleva " + sig.desde + " blusas y desbloqueas: <b>" + esc(sig.nombre.charAt(0).toLowerCase() + sig.nombre.slice(1)) + "</b>" + (n === 1 ? ", mi reina." : ".") : "<b>¡Desbloqueaste los " + REG.length + " regalos, mi reina!</b> ✨";
Q("[data-yc-reg-linea]").forEach(function (e) { html(e, l); });
Q("[data-yc-llega] li[data-desde]").forEach(function (li) { li.classList.toggle("is-no", +li.getAttribute("data-desde") > n); });
Q("[data-yc-llega-n]").forEach(function (e) { txt(e, n === 1 ? "1 blusa" : n + " blusas"); });
Q("[data-yc-llega-prendas]").forEach(function (e) { txt(e, n === 1 ? "Tu Blusa Corset" : "Tus " + n + " Blusas Corset"); });
}
var HAYCONT = !!CFG.contador, CONT = CFG.contador || { minutos: 15, avisoCada: 5 }, relojDur = (CONT.minutos || 15) * 60000, relojIni = Date.now(), relojT = null, avisados = {};
var EXP = ((CFG.envio || {}).express) || null;
var GRATIS = !!(CFG.envio && CFG.envio.gratis === true);
YC.envioGratis = GRATIS;
function restante() { return HAYCONT ? Math.max(0, relojIni + relojDur - Date.now()) : 1; }
function mmss(ms) { var s = Math.ceil(ms / 1000); return pad(Math.floor(s / 60)) + ":" + pad(s % 60); }
function esExpress() { var cn = norm(ciudad); return !!(EXP && cn && (EXP.ciudades || []).some(function (x) { return cn.indexOf(x) > -1; })); }
function tic() {
if (!HAYCONT) { pintarReloj(); return; }
var r = restante(), trans = relojDur - r, paso = (CONT.avisoCada || 5) * 60000, nuevo = null;
for (var k = paso; k < relojDur; k += paso) if (trans >= k && !avisados[k]) { avisados[k] = 1; nuevo = k; track("timer_" + Math.round(k / 60000) + "min"); }
if (r <= 0 && !avisados.fin) { avisados.fin = 1; nuevo = "fin"; track("timer_fin"); if (relojT) { clearInterval(relojT); relojT = null; } }
if (nuevo === "fin") aviso("Se terminó el tiempo, mi reina. <b>¡Aún puedes pedir tu blusa!</b> 💗", 6000);
else if (nuevo) aviso("Te quedan " + Math.round((relojDur - nuevo) / 60000) + " minutos para tus regalos ✨", 5000);
pintarReloj();
}
function pintarReloj() {
var r = restante(), fin = HAYCONT && r <= 0, t = HAYCONT ? mmss(r) : "", conExp = false;
var largo = fin ? "Se acabó el tiempo, mi reina" : conExp ? "Tus regalos y el envío express gratis te esperan:" : "Tus regalos te esperan:";
var mini = fin ? "Se acabó el tiempo" : conExp ? "Regalos y express gratis:" : "Tus regalos:";
var cifra = fin ? "¡Aún puedes pedir!" : t;
if (HAYCONT) Q("[data-yc-reloj]").forEach(function (e) {
var s = e.__ycS;
if (!s) { var c0 = $("[data-yc-reloj-t]", e); if (!c0) return; if (!c0.querySelector("b")) c0.innerHTML = "<span></span> <b></b>"; s = e.__ycS = { a: c0.querySelector("span"), b: c0.querySelector("b") }; }
e.classList.toggle("is-fin", fin); txt(s.a, e.hasAttribute("data-yc-reloj-mini") ? mini : largo); atr(s.b, "data-t", cifra);
});
var corto = fin ? "" : conExp ? " · regalos y express gratis" : " · tus regalos te esperan";
if (HAYCONT) Q("[data-yc-barra-reloj]").forEach(function (e) { atr(e, "data-t", cifra); txt(e, corto); e.classList.toggle("is-fin", fin); });
pintarExpress(fin, t);
}
function pintarExpress(fin, t) {
var box = Q("[data-yc-express]")[0];
if (!box || !EXP) return;
if (fin === undefined) { var r = restante(); fin = HAYCONT && r <= 0; t = HAYCONT ? mmss(r) : ""; }
var on = esExpress() && tramo().aviso !== false; ocultar(box, !on);
if (!on) return;
var c = /soacha/.test(norm(ciudad)) ? "Soacha" : "Bogotá", x = $("[data-yc-express-t]", box), tar = fmt(EXP.tarifa || 10000);
html(x, "Envío express en " + c + ": <b>" + (GRATIS ? "gratis" : tar) + "</b> · llega " + llegaCe + " · pagas al recibir");
}
function initReloj() {
tic();
if (HAYCONT) relojT = setInterval(function () { if (!document.hidden) tic(); }, 1000);
}
YC.adelantarReloj = function (ms) { relojIni -= ms; tic(); };
YC.hayContador = HAYCONT;
YC.restante = restante;
YC.expressGratis = function () { return false; };
var ciudad = "", region = "", ciudadGeo = "", regionGeo = "", tipoCiudad = null, ciuManual = false;
var CIUS = { bogota: "Bogotá", soacha: "Soacha", otra: "Otra ciudad" };
function tipoDe(c) { var n = norm(c); return /bogot/.test(n) ? "bogota" : /soacha/.test(n) ? "soacha" : n ? "otra" : null; }
function esContraEntrega() { return tipoCiudad === "bogota" || tipoCiudad === "soacha"; }
function htmlCiudades(suf) {
var id = "yc-ciu-panel" + (suf || "");
return '<div class="yc-ciu__conf"><p class="yc-ciu__linea" data-yc-ciu-conf aria-live="polite">' + ico("pin") + "<span></span></p>"
+ '<button type="button" class="yc-ciu__cambiar" data-yc-ciu-cambiar aria-expanded="false" aria-controls="' + id + '">Cambiar</button></div>'
+ '<div class="yc-ciu__panel" id="' + id + '" data-yc-ciu-panel hidden><div class="yc-ciu__op" data-yc-ciudades role="radiogroup" aria-label="Ciudad de entrega">'
+ Object.keys(CIUS).map(function (k) { return '<button type="button" role="radio" class="yc-ciu__b" data-yc-ciu="' + k + '" aria-checked="' + (tipoCiudad === k) + '">' + CIUS[k] + "</button>"; }).join("")
+ '</div><p class="yc-ciu__nota" data-yc-ciu-nota></p></div>';
}
function sinCiudad(abrir) {
tipoCiudad = null; ciudad = ""; region = "";
marcarDato("ciudad", "sin_detectar"); pintarEntrega();
if (abrir) $$("[data-yc-ciu-cambiar]").forEach(function (b) { var caja = b.closest(".yc-ciu"), panel = caja && $("[data-yc-ciu-panel]", caja); if (panel && panel.hidden) { panel.hidden = false; b.setAttribute("aria-expanded", "true"); b.textContent = "Listo"; } });
}
YC.sinCiudad = sinCiudad;
function elegirCiudad(k, deUsuaria) {
if (!CIUS[k]) return;
tipoCiudad = k;
if (k !== "otra") { ciudad = CIUS[k]; region = ""; }
else { var g = tipoDe(ciudadGeo); ciudad = g === "otra" ? ciudadGeo : ""; region = ciudad ? regionGeo : ""; }
if (deUsuaria) {
ciuManual = true; guardarSes("yc-ciu", k); track("ciudad_" + k);
var f = raiz.querySelectorAll(".yc-ciu.is-falta"); for (var i = 0; i < f.length; i++) f[i].classList.remove("is-falta");
}
marcarDato("ciudad", k); marcarDato("pago", esContraEntrega() ? "contra_entrega" : "anticipado");
pintarEntrega();
}
YC.elegirCiudad = elegirCiudad;
YC.ciudad = function () { return { tipo: tipoCiudad, ciudad: ciudad, manual: ciuManual }; };
function abrirCambiar(btn, abre) {
var caja = btn.closest(".yc-ciu"), panel = caja && $("[data-yc-ciu-panel]", caja); if (!panel) return;
panel.hidden = !abre; btn.setAttribute("aria-expanded", abre ? "true" : "false"); btn.textContent = abre ? "Listo" : "Cambiar";
if (abre) track("ciudad_cambiar");
}
function pintarCiudad() {
Q("[data-yc-ciu]").forEach(function (b) { atr(b, "aria-checked", b.getAttribute("data-yc-ciu") === tipoCiudad ? "true" : "false"); });
var ce = esContraEntrega();
var conf = !tipoCiudad ? "<b>Elige tu ciudad</b> · Bogotá, Soacha u otra" : ce ? "<b>Te llega a " + esc(CIUS[tipoCiudad]) + "</b> · Pagas al recibir" + (COD !== "checkout" ? "" : " (Contra Entrega)") : "<b>Te llega a " + esc(ciudad || "tu ciudad") + "</b> · Pago seguro en línea";
Q(".yc-recibe__ciu").forEach(function (e) { e.classList.toggle("is-pide", !tipoCiudad); });
Q("[data-yc-ciu-conf] > span").forEach(function (e) { html(e, conf); });
var ft = !tipoCiudad ? "CONFIRMAR PEDIDO" : ce ? "PEDIR Y PAGAR AL RECIBIR" : "IR A PAGAR SEGURO";
Q("[data-yc-fin-txt]").forEach(function (e) { txt(e, ft); e.parentNode.classList.toggle("is-largo", ft.length > 16); });
Q("[data-yc-zona]").forEach(function (e) { ocultar(e, e.getAttribute("data-yc-zona") !== (ce ? "ce" : "linea")); });
if (dlg) dlg.classList.toggle("is-ant", hayAnticipado() && dlgModo !== "carrito");
pintarCta(); pintarAccion(); luego("envio", pintarEnvio);
}
function diasResto() { var E = CFG.entrega || {}, d = E.restoDias || [3, 5]; return d[0] + " a " + d[1] + " días" + (E.restoHabiles ? " hábiles" : ""); }
function notaCiudad() {
var ce = esContraEntrega(), tar = fmt((EXP && EXP.tarifa) || 10000);
if (GRATIS) return ce ? "<b>Envío gratis · " + (COD !== "checkout" ? "pagas al recibir</b> (contra entrega)" + (hayAnticipado() ? ", o pagas ahora y ahorras " + ANT.pct + " %" : "") : "en el pago elige Contra Entrega</b>") + ". Llega " + llegaCe + "."
: "<b>Envío gratis · llega en " + diasResto() + ".</b> Pago en línea: Addi, tarjeta, PSE, Nequi, Daviplata o Sistecrédito.";
if (ce) return (COD !== "checkout" ? "<b>Pagas al recibir, en efectivo" + (hayAnticipado() ? ",</b> o pagas ahora y ahorras " + ANT.pct + " %. " : ".</b> ") : "<b>En el pago elige Contra Entrega y pagas al recibir.</b> ") + "Envío express " + tar + " · llega " + llegaCe + ".";
return "<b>Pago en línea:</b> Addi, tarjeta, PSE, Nequi o Sistecrédito. Llega en " + diasResto() + " y el envío lo pagas al recibir.";
}
var festivosCache = {};
function festivos(y) {
if (festivosCache[y]) return festivosCache[y];
var f = {}, k = function (d) { return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate(); };
var lunes = function (d) { d.setDate(d.getDate() + (8 - d.getDay()) % 7); return d; };
[[1, 1], [5, 1], [7, 20], [8, 7], [12, 8], [12, 25]].forEach(function (m) { f[k(new Date(y, m[0] - 1, m[1]))] = 1; });
[[1, 6], [3, 19], [6, 29], [8, 15], [10, 12], [11, 1], [11, 11]].forEach(function (m) { f[k(lunes(new Date(y, m[0] - 1, m[1])))] = 1; });
var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, ff = Math.floor((b + 8) / 25), g = Math.floor((b - ff + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), kk = c % 4, l = (32 + 2 * e + 2 * i - h - kk) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
var pascua = new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, (h + l - 7 * m + 114) % 31 + 1);
[-3, -2, 43, 64, 71].forEach(function (o) { var x = new Date(pascua); x.setDate(x.getDate() + o); f[k(x)] = 1; });
return (festivosCache[y] = f);
}
function habil(d) { if ((CFG.entrega || {}).todosLosDias) return true; var w = d.getDay(); return w !== 0 && w !== 6 && !festivos(d.getFullYear())[d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()]; }
function sumarHabiles(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (habil(d)) n--; } return d; }
function sumarCorridos(d, n) { d = new Date(d); d.setDate(d.getDate() + n); while (!(CFG.entrega || {}).todosLosDias && (d.getDay() === 0 || festivos(d.getFullYear())[d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()])) d.setDate(d.getDate() + 1); return d; }
YC.festivos = festivos; YC.sumarHabiles = sumarHabiles; YC.sumarCorridos = sumarCorridos;
function tramo() {
var E = CFG.entrega || {}, cn = " " + norm(ciudad) + " ", dn = norm(region), l = E.tramos || [];
for (var i = 0; i < l.length; i++) {
var t = l[i];
if ((t.ciudades || []).some(function (x) { return cn.indexOf(" " + x + " ") > -1 || cn.indexOf(" " + x) > -1; })) return t;
if (dn && !(t.express) && (t.deptos || []).some(function (x) { return dn.indexOf(x) > -1; })) return t;
}
return { dias: E.restoDias || [3, 5] };
}
YC.tramo = function (c, r) { var a = ciudad, b = region; ciudad = c || ""; region = r || ""; var t = tramo(); ciudad = a; region = b; return t; };
var llegaCe = "pronto";
function pintarEntrega() {
var E = CFG.entrega || {}, cn = norm(ciudad), tr = tramo(), r = tr.dias, hoy = new Date();
var extra = tr.sinCorte ? 0 : !habil(hoy) || hoy.getHours() >= (E.corteHora || 14) ? 1 : 0;
var a = r[0] === 0 && !extra ? new Date(hoy) : sumarHabiles(hoy, Math.max(r[0], 1) + extra - (r[0] === 0 ? 1 : 0)), b = sumarHabiles(hoy, r[1] + extra);
if (!tr.express && !tr.deptos && E.restoHabiles === false) { a = sumarCorridos(hoy, r[0]); b = sumarCorridos(hoy, r[1]); }
YC.entregaFechas = [a, b];
var dia = function (d) { var m = new Date(hoy); m.setDate(m.getDate() + 1); return d.toDateString() === hoy.toDateString() ? "hoy" : d.toDateString() === m.toDateString() ? "mañana" : null; };
var f = function (d, mes) { var x = dia(d); if (x) return x; try { return "el " + d.toLocaleDateString("es-CO", mes ? { weekday: "short", day: "numeric", month: "short" } : { weekday: "short", day: "numeric" }).replace(/[.,]/g, ""); } catch (e) { return "el " + d.getDate() + "/" + (d.getMonth() + 1); } };
var fechas = a.toDateString() === b.toDateString() ? f(b, true) : "entre " + f(a, a.getMonth() !== b.getMonth()) + " y " + f(b, true);
if (tr.express) llegaCe = dia(a) === "hoy" && dia(b) === "mañana" ? "hoy o mañana" : fechas;
Q("[data-yc-fecha]").forEach(function (e) { txt(e, fechas); });
Q("[data-yc-ciudad]").forEach(function (e) { txt(e, ciudad || "tu ciudad"); });
Q("[data-yc-ruta-ciudad]").forEach(function (e) { txt(e, ciudad || "Tu casa"); });
pintarCiudad(); pintarReloj();
}
var GEO = CFG.geo || {}, GEO_RADIO = +GEO.radioMaxKm > 0 ? +GEO.radioMaxKm : 50, GEO_ESPERA = +GEO.esperaMs > 0 ? +GEO.esperaMs : 3500;
function geoConfiable(g) {
if (!g || g.country_code !== "CO") return null;
var c = String(g.city || "").trim(), acc = parseFloat(g.accuracy);
if (!c || /^\d/.test(c) || c.length > 60 || !isFinite(acc) || acc <= 0 || acc > GEO_RADIO) return null;
if (/bogot/i.test(c)) c = "Bogotá";
return { ciudad: c, region: String(g.region || "") };
}
YC.geoConfiable = geoConfiable;
function detectarCiudad() {
var g = leerSes("yc-geo-c");
if (g !== null) { ciudadGeo = g; regionGeo = leerSes("yc-geo-r") || ""; YC.geo = g ? "sesion" : "sesion-sin-ciudad"; prellenar(); return; }
if (!window.fetch || QA) return;
var ctl = window.AbortController ? new AbortController() : null, hecho = false;
var fin = function (r, motivo) {
if (hecho) return; hecho = true; clearTimeout(t);
ciudadGeo = r ? r.ciudad : ""; regionGeo = r ? r.region : ""; YC.geo = motivo;
if (motivo !== "error" && motivo !== "tiempo") { guardarSes("yc-geo-c", ciudadGeo); guardarSes("yc-geo-r", regionGeo); }
track("geo_" + motivo); prellenar();
};
var t = setTimeout(function () { fin(null, "tiempo"); if (ctl) try { ctl.abort(); } catch (e) {} }, GEO_ESPERA);
fetch("https://get.geojs.io/v1/ip/geo.json", ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.ok ? r.json() : null; }).then(function (g) {
var r = geoConfiable(g); fin(r, r ? "ok" : g ? "sin_confianza" : "error");
}).catch(function () { fin(null, "error"); });
}
function prellenar() {
if (ciuManual) return;
var k = tipoDe(ciudadGeo); if (k) elegirCiudad(k, false); else sinCiudad(true);
}
YC.ponerCiudadGeo = function (c, r) { ciudadGeo = c || ""; regionGeo = r || ""; ciuManual = false; try { sessionStorage.removeItem("yc-ciu"); } catch (e) {} prellenar(); };
var RAIZ_TIENDA = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
function pedir(ruta, cuerpo, ms) {
var ctl = window.AbortController ? new AbortController() : null, t = ctl ? setTimeout(function () { ctl.abort(); }, ms || 15000) : 0;
var op = { credentials: "same-origin", headers: { Accept: "application/json" } };
if (cuerpo) { op.method = "POST"; op.headers["Content-Type"] = "application/json"; op.body = JSON.stringify(cuerpo); }
if (ctl) op.signal = ctl.signal;
return fetch(RAIZ_TIENDA + ruta, op).then(function (r) {
clearTimeout(t);
return r.json().catch(function () { return null; }).then(function (j) { if (!r.ok) { var e = new Error((j && (j.description || j.message)) || "HTTP " + r.status); e.status = r.status; throw e; } return j; });
}, function (e) { clearTimeout(t); var x = new Error(e && e.name === "AbortError" ? "tiempo" : "red"); x.status = 0; throw x; });
}
function esEsta(it) { var pid = DATOS.producto && DATOS.producto.id; return pid ? it.product_id === pid : VARS.some(function (v) { return String(v.id) === String(it.variant_id || it.id); }); }
function debeQuitarCodigo(c) { return conCodigo(c) || leerSes("yc-ant") === "1"; }
function limpiarPrevios(quitarCodigo) {
return pedir("cart.js").then(function (c) {
var up = {}, n = 0, cod = !!quitarCodigo && debeQuitarCodigo(c);
((c && c.items) || []).forEach(function (it) { if (it.properties && it.properties._yc && esEsta(it)) { up[it.key] = 0; n++; } });
if (cod) { track("codigo_quitado"); YC.codigoQuitado = (YC.codigoQuitado || 0) + 1; }
return n || cod ? pedir("cart/update.js", cod ? { updates: up, discount: "" } : { updates: up }) : null;
}).catch(function () { return null; });
}
var carritoN = +(raiz.getAttribute("data-yc-carrito-n") || 0);
function pintarCarrito(n) {
if (typeof n === "number") carritoN = n;
$$("[data-yc-car-n]").forEach(function (e) { e.textContent = carritoN; e.classList.toggle("is-cero", !carritoN); });
$$("[data-yc-carrito]").forEach(function (b) { b.setAttribute("aria-label", "Tu carrito: " + carritoN + (carritoN === 1 ? " producto" : " productos")); });
}
function avisarCarrito(c) {
pintarCarrito(c.item_count || 0);
try { document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true, detail: { resource: c, sourceId: "yc-blusa-corset", data: { itemCount: c.item_count, source: "yc-blusa-corset" } } })); } catch (e) {}
}
function refrescarCarrito() { return pedir("cart.js").then(function (c) { avisarCarrito(c); return c; }); }
YC.refrescarCarrito = refrescarCarrito;
function pedido(anticipado) {
var dentro = restante() > 0, reg = (dentro || CONT.regalosAlTerminar !== false) ? regalosDe(est.n).map(function (r) { return r.nombre; }) : [];
var agg = {}, orden = [], g = regaloPrenda(est.n);
est.unis.forEach(function (u) { var v = variante(u.c, u.t); if (!agg[v.id]) { agg[v.id] = 0; orden.push(v.id); } agg[v.id]++; });
var items = orden.map(function (id, i) {
var it = { id: +id, quantity: agg[id], properties: { "_yc": "1" } };
if (i === 0) {
it.properties["Paquete"] = est.n === 1 ? "1 Blusa Corset" : est.n + " Blusas Corset (" + fmt(total(est.n)) + ")";
if (reg.length) it.properties["Regalos"] = reg.join(" + ");
if (g && reg.length) it.properties["Talla de la prenda de obsequio"] = est.regaloTalla || g.tallas[0];
if (YC.expressGratis()) it.properties["Envío express"] = "Gratis (pidió dentro de los " + (CONT.minutos || 15) + " min)";
if (anticipado && ANT) it.properties["Pago"] = "Anticipado con " + ANT.pct + " % de descuento (" + ANT.codigo + ")";
it.properties["_entrega"] = tipoCiudad || "";
if (HAYCONT) it.properties["_contador"] = dentro ? "dentro" : "terminado";
}
return it;
});
return { items: items };
}
YC.pedido = pedido;
var RS = CFG.releasit || { activo: true, espera: 8000 };
function abrirReleasit(token) {
return new Promise(function (ok, mal) {
if (COD !== "releasit" || !token) { mal(new Error("sin releasit")); return; }
var t0 = Date.now(), max = YC.esperaReleasit || RS.espera || 8000;
(function intentar() {
var r = window._rsiV2;
if (r && typeof r.setState === "function" && r.cartService && typeof r.cartService.getCart === "function") {
var id = /^gid:/.test(token) ? token : "gid://shopify/Cart/" + token;
Promise.resolve(r.cartService.getCart(id)).then(function (x) {
var cart = x && x.data && x.data.cart, ed = cart && cart.lines && cart.lines.edges;
if (!ed || !ed.length) throw new Error("carrito vacío");
var m = ed[0].node.merchandise, idn = function (g) { return Number(String(g || "").split("/").pop()) || undefined; };
r.setState({ cartInfo: cart, currentVariantId: idn(m && m.id), currentProductId: idn(m && m.product && m.product.id), isOpen: true });
ok();
}).catch(mal);
return;
}
if (Date.now() - t0 < max) setTimeout(intentar, 150); else mal(new Error("releasit no cargó"));
})();
});
}
function urlCheckout(codigo) {
var u = RAIZ_TIENDA + "checkout";
try { u = YC_CHECKOUT.url(RAIZ_TIENDA, { tipo: tipoCiudad, ciudad: ciudad, region: region }, codigo); } catch (e) {}
return u;
}
YC.urlCheckout = urlCheckout;
function irCheckout(codigo) { if (codigo) guardarSes("yc-ant", "1"); track("checkout_redirect"); YC.ultimaRuta = codigo ? "checkout-anticipado" : "checkout"; var u = urlCheckout(codigo); YC.ultimaUrl = u; location.href = u; }
var enviando = false;
function errorCompra(e, btn) {
enviando = false; dlgCompro = false; if (btn) btn.removeAttribute("aria-busy");
var por = e.status === 0 ? (e.message === "tiempo" ? "La conexión está muy lenta" : "Parece que se fue la conexión") : e.status === 422 ? "Una de las tallas se acaba de agotar o no quedan suficientes unidades" : "No pudimos preparar tu pedido";
if (window.console) console.warn("yc carrito", e.status, e.message);
var msg = esc(por) + ". Intenta de nuevo, mi reina." + (TIENDA.whatsappVisible ? " Si sigue fallando, llámanos al " + esc(TIENDA.whatsappVisible) + "." : "");
var err = $("[data-yc-dlg][open] [data-yc-dlg-err]"); if (err) err.textContent = msg.replace(/<[^>]+>/g, "");
aviso(msg, 10000);
}
var ES = CFG.easysell || {}, ES_BOTONES = ES.botones || [".es-form-button", ".es-popup-button-product", "#es-sticky.es-sticky-product", "#es-sticky"], ES_MODAL = ES.modal || "#easysell-modal";
function visible(m) { if (!m) return false; var st = getComputedStyle(m); return st.display !== "none" && st.visibility !== "hidden" && m.getBoundingClientRect().height > 0; }
function modalCod() { var m = document.querySelector(ES_MODAL); return visible(m) ? m : null; }
function botonEasySell() { for (var i = 0; i < ES_BOTONES.length; i++) { var b = document.querySelector(ES_BOTONES[i]); if (b) return b; } return null; }
YC.modalCod = modalCod;
function extras() { try { return JSON.parse(leerSes("yc-extras") || "[]"); } catch (e) { return []; } }
function unidadesDe(c) { var k = 0; ((c && c.items) || []).forEach(function (it) { if (esEsta(it)) k += it.quantity || 0; }); return k; }
function conCodigo(c) { return !!(c && (((c.discount_codes || []).length) || ((c.cart_level_discount_applications || []).some(function (d) { return d && (d.type === "discount_code" || d.discount_code || d.code); })))); }
YC.conCodigo = conCodigo;
function dejarSoloExtras() {
return pedir("cart.js").then(function (c) {
var up = {}, k = 0, ex = extras(), cod = debeQuitarCodigo(c);
((c && c.items) || []).forEach(function (it) { if (esEsta(it) || ex.indexOf(String(it.variant_id || it.id)) < 0) { up[it.key] = 0; k++; } });
if (cod) track("easysell_codigo_quitado");
return k || cod ? pedir("cart/update.js", cod ? { updates: up, discount: "" } : { updates: up }) : c;
});
}
function ponerFormApp(it) {
var f = document.getElementById("yc-form-app"); if (!f) return false;
var id = f.querySelector('[name="id"]'), q = f.querySelector('[name="quantity"]'); if (id) id.value = it.id; if (q) q.value = it.quantity || 1;
var viejas = f.querySelectorAll("[data-yc-prop]"); for (var i = 0; i < viejas.length; i++) viejas[i].parentNode.removeChild(viejas[i]);
Object.keys(it.properties || {}).forEach(function (k) { var h = document.createElement("input"); h.type = "hidden"; h.name = "properties[" + k + "]"; h.value = it.properties[k]; h.setAttribute("data-yc-prop", ""); f.appendChild(h); });
return true;
}
function abrirEasySell(cuerpo, btn) {
var items = cuerpo.items, modoProd = ES.modo !== "carrito", ultima = { id: items[0].id, quantity: modoProd ? 1 : items[0].quantity, properties: items[0].properties }; // modo "carrito": EasySell iguala la cantidad de la variante del formulario a la del formulario (visto en Yass 11-oct), así que debe llevar la cantidad real
var antes = !modoProd ? items : items.map(function (x, i) { return i ? x : { id: x.id, quantity: x.quantity - 1, properties: x.properties }; }).filter(function (x) { return x.quantity > 0; });
var completar = function () { return modoProd ? pedir("cart/add.js", { items: [ultima] }) : Promise.resolve(); };
var alCheckout = function (falta) { YC.easysell = { ok: false, motivo: falta }; track("easysell_respaldo"); if (falta !== "sin-unidad") { irCheckout(); return; } return completar().then(irCheckout, function (e) { errorCompra(e, btn); }); };
return dejarSoloExtras()
.then(function () { return antes.length ? pedir("cart/add.js", { items: antes }) : null; })
.then(function () { return pedir("cart.js").catch(function () { return null; }); })
.then(function (c) {
if (c) avisarCarrito(c);
cerrarDlg(true);
var esperado = est.n, previo = c ? unidadesDe(c) : -1;
if (c && previo !== esperado - (modoProd ? 1 : 0)) { if (window.console) console.warn("yc easysell: carrito inesperado", previo, esperado); }
ponerFormApp(ultima);
aviso("Abriendo tu pedido contra entrega…", 4000);
var t0 = Date.now(), max = YC.esperaEasySell || ES.espera || 8000;
return new Promise(function (listo) {
(function intentar() {
var b = botonEasySell();
if (!b) { if (Date.now() - t0 < max) setTimeout(intentar, 120); else listo(alCheckout("sin-unidad")); return; }
b.click();
var t1 = Date.now();
(function ver() {
if (modalCod()) {
enviando = false; if (btn) btn.removeAttribute("aria-busy");
YC.ultimaRuta = "easysell"; YC.easysell = { ok: true, esperado: esperado }; track("easysell_abierto"); actualizarBarra(); vigilarCod();
setTimeout(function () { pedir("cart.js").then(function (c2) { var real = unidadesDe(c2); YC.easysell.real = real; avisarCarrito(c2); if (real === esperado - 1 && modoProd) { track("easysell_ajuste"); YC.easysell.ajuste = true; return completar().then(refrescarCarrito); } if (real !== esperado) track("easysell_descuadre"); }).catch(function () {}); }, 1500);
listo(); return;
}
if (Date.now() - t1 < 4000) setTimeout(ver, 100);
else pedir("cart.js").then(function (c2) { listo(alCheckout(unidadesDe(c2) >= esperado ? "sin-formulario" : "sin-unidad")); }, function () { listo(alCheckout("sin-unidad")); });
})();
})();
});
});
}
var codT = 0;
function vigilarCod() { clearInterval(codT); codT = setInterval(function () { if (!modalCod()) { clearInterval(codT); codT = 0; actualizarBarra(); } }, 400); }
function limpiarCodigo() { return pedir("cart.js").then(function (c) { if (!debeQuitarCodigo(c)) return null; track("codigo_quitado"); return pedir("cart/update.js", { discount: "" }); }).catch(function () { return null; }); }
function finalizar(btn, agregar, anticipado) {
popAutoFin("fue_a_pagar");
if (enviando) return;
if (!tipoCiudad) { abrirDlg(agregar ? "unidades" : "carrito", null, btn); return; }
var cuerpo = agregar ? pedido(anticipado) : null; if (cuerpo) YC.ultimoPedido = cuerpo;
enviando = true; if (btn) btn.setAttribute("aria-busy", "true");
track("comprar_click"); marcarDato("pago", esContraEntrega() && !anticipado ? "contra_entrega" : "anticipado");
if (agregar && anticipado) {
limpiarPrevios().then(function () { return pedir("cart/add.js", cuerpo); }).then(function () { return pedir("cart.js").catch(function () { return null; }); })
.then(function (c) { if (c) avisarCarrito(c); cerrarDlg(true); irCheckout(ANT.codigo); }).catch(function (e) { errorCompra(e, btn); });
return;
}
if (agregar && esContraEntrega() && COD === "easysell") { abrirEasySell(cuerpo, btn).catch(function (e) { errorCompra(e, btn); }); return; }
var paso = agregar ? limpiarPrevios(true).then(function () { return pedir("cart/add.js", cuerpo); }) : limpiarCodigo();
paso.then(function () { return pedir("cart.js").catch(function () { return null; }); })
.then(function (c) { if (c && conCodigo(c)) { track("codigo_quitado_2"); return pedir("cart/update.js", { discount: "" }).then(function () { return pedir("cart.js"); }).catch(function () { return c; }); } return c; })
.then(function (c) {
if (c) avisarCarrito(c);
cerrarDlg(true);
if (!esContraEntrega() || COD !== "releasit") { irCheckout(); return; }
aviso("Abriendo tu pedido contra entrega…", 4000);
return abrirReleasit(c && c.token).then(function () {
enviando = false; if (btn) btn.removeAttribute("aria-busy");
YC.ultimaRuta = "releasit"; track("releasit_abierto");
}, function (e) { if (window.console) console.warn("yc releasit", e && e.message); irCheckout(); });
})
.catch(function (e) { errorCompra(e, btn); });
}
function tallasALaVista() { if (!boxTallas) return false; var r = boxTallas.getBoundingClientRect(); return r.bottom > 0 && r.top >= 0 && r.bottom <= (window.innerHeight || 0); }
function pedirTalla() {
if (!campoTalla) return; var ver = !tallasALaVista();
reanimar(campoTalla, "is-falta"); track("falta_talla");
if (ver) { try { campoTalla.scrollIntoView({ behavior: comp, block: "center" }); } catch (e) {} }
for (var k = 0; k < btnsTalla.length; k++) if (btnsTalla[k].getAttribute("aria-disabled") !== "true") { try { btnsTalla[k].focus({ preventScroll: true }); } catch (e) {} break; }
}
YC.pedirTalla = pedirTalla;
function comprar(btn, anticipado) {
if (enviando) return;
if (est.n > 1) { abrirTras(btn, function () { abrirDlg("unidades", null, btn); }); return; }
var u = u0();
if (!u.t || !hayStock(u.c, u.t)) {
if ((accion && btn && accion.contains(btn)) || tallasALaVista()) { pedirTalla(); return; }
track("hoja_rapida"); abrirTras(btn, function () { abrirDlg("unidades", null, btn); }); return;
}
anticipado = !!(anticipado && hayAnticipado());
track("compra_directa_1"); if (anticipado) track("directa_pagar_anticipado"); else if (esContraEntrega()) track("directa_pagar_contraentrega");
finalizar(btn, true, anticipado);
}
YC.comprar = comprar;
function comprarBarra(btn) { if (enviando) return; track("barra_comprar"); comprar(btn); }
window.addEventListener("pageshow", function (e) { if (e.persisted) { enviando = false; $$("[aria-busy]").forEach(function (b) { b.removeAttribute("aria-busy"); }); refrescarCarrito().catch(function () {}); } });
var dlg = null, dlgModo = null, dlgOrigen = null, dlgHist = false, dlgCompro = false, dlgFondo = null;
function crearDlg() {
if (dlg) return dlg;
soltarDiferidas();
dlg = document.createElement("dialog");
dlg.className = "yc-dlg yc-hoja yc-pop is-nm"; dlg.setAttribute("aria-modal", "true"); dlg.setAttribute("data-yc-dlg", ""); dlg.setAttribute("aria-labelledby", "yc-dlg-t");
dlg.innerHTML = '<div class="yc-dlg__in"><div class="yc-dlg__cab"><h2 id="yc-dlg-t" data-yc-dlg-t>Elige color y talla</h2><button type="button" class="yc-dlg__x" data-yc-dlg-cerrar aria-label="Cerrar">' + ico("cerrar") + '</button></div>'
+ '<div class="yc-dlg__cuerpo">' + (HAYCONT ? '<p class="yc-reloj" data-yc-reloj role="timer">' + ico("reloj") + '<span data-yc-reloj-t></span></p>' : "")
+ '<div class="yc-unis" data-yc-unis>' + htmlUnis() + "</div>"
+ '<p class="yc-pop__talla">' + ico("metro") + '<span><b>Pide tu talla de siempre.</b> <a href="#yc-tallas">Ver guía de tallas</a></span></p>'
+ '<ul class="yc-dlg__lineas" data-yc-dlg-lineas hidden></ul>'
+ '<div class="yc-hoja__g yc-ciu yc-pop__ciu"><p class="yc-hoja__t">¿Dónde la recibes?</p><div class="yc-ciu__op" data-yc-ciudades role="radiogroup" aria-label="Ciudad de entrega">'
+ Object.keys(CIUS).map(function (k) { return '<button type="button" role="radio" class="yc-ciu__b" data-yc-ciu="' + k + '" aria-checked="' + (tipoCiudad === k) + '">' + CIUS[k] + "</button>"; }).join("")
+ '</div><p class="yc-ciu__nota" data-yc-ciu-nota></p></div>' + htmlRegaloTalla() + "</div>"
+ '<div class="yc-dlg__pie"><p class="yc-dlg__err" data-yc-dlg-err role="alert"></p><p class="yc-dlg__va" data-yc-dlg-va></p><p class="yc-dlg__tot"><span data-yc-dlg-tot-t>Total</span><b data-yc-dlg-total></b></p><button type="button" class="yc-cta" data-yc-finalizar><span data-yc-fin-txt>CONFIRMAR PEDIDO</span>' + ico("flecha") + "</button>"
+ (ANT ? '<button type="button" class="yc-ant" data-yc-finalizar-ant><span class="yc-ant__t">PAGAR AHORA <b class="yc-eg">−' + ANT.pct + ' %</b></span><small data-yc-ant-det></small></button>' : "") + "</div></div>";
var mp0 = $(".yc-mp"), tip0 = $(".yc-addi-tip"), pie0 = dlg.querySelector(".yc-dlg__pie"); if (mp0 && pie0) { pie0.appendChild(mp0.cloneNode(true)); if (tip0) pie0.appendChild(tip0.cloneNode(true)); }
raiz.appendChild(dlg); olvidar();
dlgFondo = document.createElement("div"); dlgFondo.className = "yc-dlg-fondo"; dlgFondo.hidden = true; dlgFondo.setAttribute("aria-hidden", "true");
raiz.insertBefore(dlgFondo, dlg); dlgFondo.addEventListener("click", function () { if (dlg.open) dlg.close(); });
dlg.addEventListener("keydown", function (e) { if (e.key === "Escape" && dlg.open) { e.preventDefault(); dlg.close(); } });
dlg.__ycRegt = dlg.querySelector("[data-yc-regt]");
popFilas = $$("[data-yc-uni]", dlg);
popFilas.forEach(function (f) { f.__ycB = { c: f.querySelectorAll("[data-yc-uc]"), t: f.querySelectorAll("[data-yc-ut]") }; });
cada(".yc-cta[data-yc-finalizar]", initCta, dlg);
dlg.addEventListener("close", function () {
if (dlgModo === "unidades" && !dlgCompro) track("popup_cerrado_sin_comprar");
popAutoCerrado(); dlg.removeAttribute("data-auto");
dlg.removeAttribute("data-modo"); if (dlgFondo) dlgFondo.hidden = true; actualizarBarra();
if (dlgHist && history.state && history.state.ycDlg) { dlgHist = false; history.back(); }
dlgHist = false;
var o = dlgOrigen; requestAnimationFrame(function () { requestAnimationFrame(function () { if (o && document.contains(o) && !hayModal()) try { o.focus({ preventScroll: true }); } catch (e) {} }); });
});
dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
atraparFoco(dlg);
return dlg;
}
function atraparFoco(d) {
d.addEventListener("keydown", function (e) {
if (e.key !== "Tab") return;
var f = $$('button:not([disabled]),[href],input,[tabindex="0"]', d).filter(function (x) { return x.offsetParent !== null && x.tabIndex >= 0; });
if (!f.length) return; var a = f[0], z = f[f.length - 1];
if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
});
}
var PA = CFG.popAuto && CFG.popAuto.activo ? CFG.popAuto : null, paT = [], paFin = !PA, popAutoAbierto = 0;
function popAutoCerrado() { if (!popAutoAbierto) return; var ms = Date.now() - popAutoAbierto; popAutoAbierto = 0; if (ms < (+(PA && PA.cerroRapidoMs) || 4000) && !dlgCompro) { track("popup_auto_cerrado_rapido"); popAutoFin("cerro_rapido"); } }
function popAutoFin(motivo) { if (paFin) return; paFin = true; YC.popAuto = motivo; paT.forEach(clearTimeout); paT = []; }
function popAutoHechos() { return +(leerSes("yc-popauto") || 0) || 0; }
function pantallaCompleta() { try { if (document.fullscreenElement || document.webkitFullscreenElement) return true; var v = document.querySelectorAll("video"); for (var i = 0; i < v.length; i++) if (v[i].webkitDisplayingFullscreen) return true; } catch (e) {} return false; }
function popAutoAbrir(n) {
if (paFin) return;
if (document.hidden) { var alVolver = function () { if (document.hidden) return; document.removeEventListener("visibilitychange", alVolver); paT.push(setTimeout(function () { popAutoAbrir(n); }, 1500)); }; document.addEventListener("visibilitychange", alVolver); return; }
var max = (PA.segundos || []).length || 2;
if (popAutoHechos() >= max) { popAutoFin("tope"); return; }
if (enviando || YC.ultimaRuta || hayModal() || modalCod() || document.querySelector(".yc-modal[open], dialog[open]") || pantallaCompleta()) { track("popup_auto_omitido"); return; }
guardarSes("yc-popauto", String(popAutoHechos() + 1));
track("popup_auto_" + n); YC.popAutoN = n;
abrirDlg("unidades", null, null, true);
if (dlg) { dlg.setAttribute("data-auto", String(n)); popAutoAbierto = Date.now(); }
}
function popAutoArrancar() {
if (paFin) return;
(PA.segundos || [45, 90]).slice(0, 2).forEach(function (s, i) { if (i >= popAutoHechos() && +s > 0) paT.push(setTimeout(function () { popAutoAbrir(i + 1); }, (YC.popAutoEscala || 1) * s * 1000)); });
}
YC.popAutoArrancar = function () { paT.forEach(clearTimeout); paT = []; popAutoArrancar(); };
function hayModal() { return !!((dlg && dlg.open) || (dlgGuia && dlgGuia.open)); }
window.addEventListener("popstate", function () {
if (ignorarPop) { ignorarPop = false; return; }
if (dlgGuia && dlgGuia.open) { guiaHist = false; dlgGuia.close(); return; }
if (dlg && dlg.open) { dlgHist = false; dlg.close(); }
});
function abrirDlg(modo, lineas, origen, auto) {
if (!auto) popAutoFin("abrio_popup");
crearDlg(); if (modo !== "carrito") modo = "unidades";
dlgModo = modo; dlg.setAttribute("data-modo", modo);
var t = $("[data-yc-dlg-t]", dlg), li = $("[data-yc-dlg-lineas]", dlg), err = $("[data-yc-dlg-err]", dlg);
if (err.firstChild) err.textContent = "";
popFilas.forEach(function (f) { f.classList.remove("is-falta"); }); if (dlg.__ycRegt) dlg.__ycRegt.classList.remove("is-falta");
txt(t, modo === "carrito" ? "Tu carrito" : est.n === 1 ? "Elige tu talla" : "Color y talla de tus " + est.n + " blusas");
ocultar(li, modo !== "carrito");
if (modo === "carrito") li.innerHTML = (lineas || []).map(function (x) { return "<li><span>" + esc(x.product_title || x.title) + (x.variant_title ? " · " + esc(x.variant_title) : "") + " × " + x.quantity + "</span><b>" + fmt((x.final_line_price || x.line_price || 0) / 100) + "</b></li>"; }).join("");
if (modo === "carrito") { html($("[data-yc-dlg-tot-t]", dlg), "Total del carrito"); html($("[data-yc-dlg-va]", dlg), ""); }
pintarPop(); pintarPrecios(); pintarCiudad(); pintarReloj(); rovingTodo();
if (modo === "carrito") { var tot = (lineas || []).reduce(function (a, x) { return a + (x.final_line_price || x.line_price || 0); }, 0); $("[data-yc-dlg-total]", dlg).textContent = fmt(tot / 100); }
if (!dlg.open) {
dlgOrigen = origen || document.activeElement; dlgCompro = false;
if (dlgFondo) dlgFondo.hidden = false;
try { dlg.show(); } catch (e) { dlg.setAttribute("open", ""); }
try { var pf = dlg.querySelector("[data-yc-dlg-cerrar]"); if (pf && !dlg.contains(document.activeElement)) pf.focus({ preventScroll: true }); } catch (e) {}
try { history.pushState({ ycDlg: 1 }, ""); dlgHist = true; } catch (e) {}
var cu = $(".yc-dlg__cuerpo", dlg); if (cu) cu.scrollTop = 0;
track("popup_abierto"); if (modo === "unidades") track("popup_compra_abierto"); actualizarBarra();
}
}
function cerrarDlg(sinHistoria) { if (!dlg || !dlg.open) return; if (sinHistoria) dlgHist = false; dlg.close(); }
YC.abrirDlg = abrirDlg; YC.cerrarDlg = cerrarDlg;
function validarDlg() {
var err = $("[data-yc-dlg-err]", dlg), msg = "", primera = -1;
if (dlgModo === "unidades") {
est.unis.forEach(function (u, i) {
var mal = !u.t || !hayStock(u.c, u.t); popFilas[i].classList.toggle("is-falta", mal);
if (mal && primera < 0) { primera = i; msg = est.n === 1 ? (!u.t ? "Te falta elegir la talla de tu blusa, mi reina." : "La talla " + u.t + " en " + u.c + " está agotada. Elige otra.") : (!u.t ? "Te falta la talla de la blusa " + (i + 1) + ", mi reina." : "La talla " + u.t + " en " + u.c + " está agotada (blusa " + (i + 1) + ")."); }
});
if (primera >= 0) { try { popFilas[primera].scrollIntoView({ behavior: comp, block: "center" }); } catch (e) {} reanimar(popFilas[primera].querySelector(".yc-uni__ts"), "is-sacude"); }
var g = regaloSeguir(), rb = dlg.__ycRegt;
if (!msg && g && !est.regaloTalla) { msg = "Elige la talla de tu " + (g.prenda || "prenda").toLowerCase() + " de regalo."; if (rb) { rb.classList.add("is-falta"); try { rb.scrollIntoView({ behavior: comp, block: "center" }); } catch (e) {} } }
}
if (!msg && !tipoCiudad) { msg = "Elige dónde la recibes: Bogotá, Soacha u otra ciudad."; var c = $(".yc-ciu", dlg); if (c) { reanimar(c, "is-falta"); } }
err.textContent = msg;
return !msg;
}
function alFinalizarDlg(btn, anticipado) {
if (!validarDlg()) return;
anticipado = !!(anticipado && hayAnticipado() && dlgModo !== "carrito");
track("popup_completo"); track("popup_comprar"); dlgCompro = true;
if (anticipado) track("popup_pagar_anticipado"); else if (esContraEntrega() && dlgModo !== "carrito") track("popup_pagar_contraentrega");
finalizar(btn, dlgModo !== "carrito", anticipado);
}
function abrirCarrito() {
if (TIENDA.carrito === "pagina") {
var ir = function () { YC.ultimaRuta = "carrito"; location.href = RAIZ_TIENDA + "cart"; };
refrescarCarrito().then(function (c) { if (c && c.item_count) ir(); else aviso("Tu carrito está vacío, mi reina. Elige tu blusa ✨"); }, ir);
return;
}
if (!carritoN) { aviso("Tu carrito está vacío, mi reina. Elige tu blusa ✨"); return; }
refrescarCarrito().then(function (c) { if (!c.item_count) { aviso("Tu carrito está vacío, mi reina. Elige tu blusa ✨"); return; } abrirDlg("carrito", c.items, $("[data-yc-carrito]")); }, function () { aviso("No pudimos abrir tu carrito. Intenta de nuevo."); });
}
function alScroll(fn) { document.addEventListener("scroll", fn, { passive: true, capture: true }); }
var actualizarBarra = function () {};
var barraToco = false, tocoSelector = function () {};
function initBarra() {
var barra = $("[data-yc-barra]"), ancla = ctaMain; if (!barra || !ancla) return;
var antes = null, altoB = 0, finEl = null;
function medir() {
var h = innerHeight, r0 = ancla.getBoundingClientRect(), rr = raiz.getBoundingClientRect();
if (!altoB && antes) altoB = barra.offsetHeight + 8;
var main = r0.bottom > 0 && r0.top < h - (antes ? altoB : 0), on = !main && (barraToco || -rr.top > h * 0.5);
if (on) { finEl = finEl || document.getElementById("yc-cierre"); if (finEl) { var r = finEl.getBoundingClientRect(); if (r.top < h && r.bottom > 0) on = false; } }
if (hayModal() || modalCod()) on = false;
return { on: on, r0: r0, h: h };
}
function poner(on) {
if (on === antes) return false; antes = on;
barra.classList.toggle("is-on", on); barra.setAttribute("aria-hidden", on ? "false" : "true");
if (on) { barra.removeAttribute("inert"); if (prog) prog(); } else barra.setAttribute("inert", "");
return true;
}
var revisar = porFrame(function () { poner(medir().on); });
actualizarBarra = revisar;
tocoSelector = function () { barraToco = true; poner(medir().on); };
alScroll(revisar); window.addEventListener("resize", revisar); revisar();
var animsP = null;
var prog = porFrame(function () {
if (!antes) return;
if (!animsP) { animsP = []; $$(".yc-barra__prog i, .yc-barra__cor", barra).forEach(function (e) { if (e.getAnimations) e.getAnimations().forEach(function (a) { try { a.pause(); animsP.push(a); } catch (x) {} }); }); }
if (!animsP.length) return;
var r = raiz.getBoundingClientRect(), p = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - innerHeight)));
animsP.forEach(function (a) { try { a.currentTime = p * 1000; } catch (x) {} });
YC.progreso = p;
});
alScroll(prog);
}
function saludar() {
var h = new Date().getHours(), s = h >= 5 && h < 12 ? "Buenos días" : h >= 12 && h < 19 ? "Buenas tardes" : "Buenas noches";
$$("[data-yc-saludo]").forEach(function (e) { if (e.firstChild && e.firstChild.nodeType === 3) e.firstChild.nodeValue = s + ", mi reina "; });
}
var ojo = hayIO && !reducido ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-visto"); ojo.unobserve(e.target); } }); }, { rootMargin: "0px 0px -10% 0px" }) : null;
function initVer(e) { if (ojo) ojo.observe(e); else e.classList.add("is-visto"); }
var ojoCta = hayIO && !reducido ? new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle("is-vista", e.isIntersecting); }); }) : null;
function initCta(e) { if (ojoCta) ojoCta.observe(e); }
function estrellas(v) {
var s = "", i; for (i = 0; i < 5; i++) s += '<svg viewBox="0 0 24 24" aria-hidden="true"><use href="#yc-g-estrella"></use></svg>';
return '<span style="display:inline-flex;color:#e8dde1">' + s + '</span><span style="position:absolute;left:0;top:0;bottom:0;display:inline-flex;overflow:hidden;color:var(--yc-rosa);width:' + Math.max(0, Math.min(100, v / 5 * 100)).toFixed(1) + '%">' + s + "</span>";
}
function coma(v) { return String(v).replace(".", ","); }
function pintarRatings() {
var R = TIENDA.rating || {}, rt = R.tienda, a = $("[data-yc-rating]");
if (a) { if (!rt || !rt.cantidad) a.hidden = true; else { var s = $("[data-yc-rating-s]", a); s.innerHTML = estrellas(rt.valor); s.style.position = "relative"; $("[data-yc-rating-v]", a).textContent = coma(rt.valor); $("[data-yc-rating-n]", a).textContent = "· " + rt.cantidad + " reseñas de clientas Yass"; a.setAttribute("aria-label", coma(rt.valor) + " de 5 estrellas: " + rt.cantidad + " reseñas de la tienda Yass. Ver reseñas"); } }
$$("[data-yc-estrellas]:not([data-ok])").forEach(function (e) { e.setAttribute("data-ok", ""); if (rt) { e.style.position = "relative"; e.innerHTML = estrellas(rt.valor); } });
if (rt) { $$("[data-yc-r-tienda-v]").forEach(function (e) { e.textContent = coma(rt.valor); }); $$("[data-yc-r-tienda-n]").forEach(function (e) { e.textContent = rt.cantidad; }); }
}
function abrirAcc(b, si) {
var r = document.getElementById(b.getAttribute("aria-controls")); if (!r) return;
b.setAttribute("aria-expanded", si ? "true" : "false");
if (si) r.removeAttribute("hidden"); else r.setAttribute("hidden", "until-found");
$$("[data-yc-loop-acc]", r).forEach(function (l) {
if (si) {
var p = $("img[data-yc-src]", l); if (p) { p.src = p.getAttribute("data-yc-src").replace(/^assets\//, BASE); p.removeAttribute("data-yc-src"); }
if (vivos && !reducido && !l.__ycObs) { l.__ycObs = 1; vivos.observe(l); }
} else pausar(l);
});
}
function initAcc(box) {
$$("[aria-controls]", box).forEach(function (b) {
var r = document.getElementById(b.getAttribute("aria-controls"));
if (r) r.addEventListener("beforematch", function () { abrirAcc(b, true); });
});
}
function resolverFotos(base) {
$$("img[data-yc-foto-k], img[data-yc-foto-color]", base).forEach(function (im) {
var k = (CFG.fotosSecciones || {})[im.getAttribute("data-yc-foto-k")], c = im.getAttribute("data-yc-foto-color"), fn = +im.getAttribute("data-yc-foto-n") || 0;
var fc = c ? fotosDe(c) : [], f = k ? fotoPorId[k.id] || fotosDe(k.color || colores[0])[k.n || 0] : c ? fc[fn] || fc[0] : null;
f = f || FOTOS[0]; if (!f) return;
im.setAttribute("srcset", srcset(f)); im.setAttribute("sizes", im.getAttribute("data-yc-sizes") || "100vw"); im.src = url(f, 720);
im.width = f.w; im.height = f.h; im.removeAttribute("data-yc-foto-k"); im.removeAttribute("data-yc-foto-color"); im.removeAttribute("data-yc-foto-n");
});
}
function initCarr(c) {
var p = $("[data-yc-carr-pista]", c), sel = c.getAttribute("data-yc-items"), libre = c.hasAttribute("data-yc-libre"), items = sel ? $$(sel, p) : Array.prototype.slice.call(p.children), box = $("[data-yc-puntos]", c), centrado = c.hasAttribute("data-yc-centrado") || c.hasAttribute("data-yc-snap-centro"), arrancaEn1 = c.hasAttribute("data-yc-centrado");
if (sel) items.sort(function (a, b) { return a.offsetLeft - b.offsetLeft; });
var cont = $("[data-yc-contador]", c);
if (!sel) items = items.filter(function (it) { return !it.hidden; });
if (box) box.innerHTML = items.map(function () { return "<i></i>"; }).join("");
var pts = box ? $$("i", box) : [], pr = $("[data-yc-prev]", c), nx = $("[data-yc-next]", c), act = -1;
function pintarCont() { if (cont) cont.textContent = (Math.max(0, act) + 1) + " / " + items.length; }
c.__refrescar = function () { items = Array.prototype.slice.call(p.children).filter(function (it) { return !it.hidden; }); act = -1; marcar(); };
function actual() { if (!arrancaEn1) { if (p.scrollLeft <= 2) return 0; if (p.scrollLeft >= p.scrollWidth - p.clientWidth - 2) return items.length - 1; } var cx = p.scrollLeft + (centrado ? p.clientWidth / 2 : 0), m = 0, d = 1e9; items.forEach(function (it, k) { var x = it.offsetLeft - p.offsetLeft + (centrado ? it.offsetWidth / 2 : 0), dd = Math.abs(x - cx - (centrado ? 0 : 16)); if (dd < d) { d = dd; m = k; } }); return m; }
function marcar() { var i = actual(); if (i === act) return; act = i; pintarCont(); pts.forEach(function (x, k) { x.classList.toggle("is-act", k === i); }); if (pr) pr.disabled = i === 0; if (nx) nx.disabled = i === items.length - 1; items.forEach(function (it, k) { it.classList.toggle("is-act", k === i); if (k !== i && !libre) pausar(it); }); }
function ir(i) { i = Math.max(0, Math.min(items.length - 1, i)); var it = items[i]; p.scrollTo({ left: it.offsetLeft - p.offsetLeft - (centrado ? (p.clientWidth - it.offsetWidth) / 2 : 16), behavior: comp }); }
p.addEventListener("scroll", porFrame(marcar), { passive: true });
var a0 = 0; p.addEventListener("pointerdown", function () { a0 = act; });
arrastrar(p, function (dx) { var i = actual(); if (i === a0 && Math.abs(dx) > 40) i += dx < 0 ? 1 : -1; ir(i); });
if (pr) pr.addEventListener("click", function () { ir(act - 1); });
if (nx) nx.addEventListener("click", function () { ir(act + 1); });
c.__irA = function (el) { ir(items.indexOf(el)); };
if (arrancaEn1 && items.length > 2) { requestAnimationFrame(function () { var it = items[1]; p.scrollLeft = it.offsetLeft - p.offsetLeft - (p.clientWidth - it.offsetWidth) / 2; marcar(); }); } else marcar();
}
function pausar(v) { var vid = v.querySelector && v.querySelector("video"); if (vid && !vid.paused) { try { vid.pause(); } catch (e) {} } }
function srcVideo(id) {
var l = (CFG.videos || []).concat([CFG.videoFabrica, CFG.videoHistoria, CFG.videoTiendas]).filter(Boolean);
for (var i = 0; i < l.length; i++) if (l[i].id === id && l[i].src) return l[i].src;
var m = window.YC_VIDEOS_MAP || {}, f = "yc-reel-" + id + ".mp4";
return m[f] || m[id] || (window.YC_VIDEOS ? window.YC_VIDEOS + f : null);
}
var vigiaVid = hayIO ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.intersectionRatio < 0.35) pausar(e.target); }); }, { threshold: [0, 0.35] }) : null;
var lejosVid = hayIO ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) liberar(e.target); }); }, { rootMargin: "1500px 0px" }) : null;
function liberar(v) {
var vid = v.querySelector("video"); if (!vid) return;
try { vid.pause(); vid.removeAttribute("src"); vid.load(); } catch (e) {}
vid.parentNode.removeChild(vid); v.classList.remove("is-sonando", "is-lista");
if (vigiaVid) vigiaVid.unobserve(v); if (lejosVid) lejosVid.unobserve(v);
}
document.addEventListener("visibilitychange", function () { if (document.hidden) $$(".yc-vid, .yc-loop").forEach(pausar); else refrescarCarrito().catch(function () {}); });
function reproducir(v) {
var carr = v.closest("[data-yc-centrado]");
if (carr && !v.classList.contains("is-act") && carr.__irA) { carr.__irA(v); return; }
var vid = v.querySelector("video");
if (vid && !vid.paused) { vid.pause(); return; }
$$(".yc-vid").forEach(function (o) { if (o !== v) pausar(o); });
if (!vid) {
var s = srcVideo(v.getAttribute("data-yc-vid"));
if (!s) { aviso("Este video estará disponible muy pronto 💗"); return; }
vid = document.createElement("video");
vid.playsInline = true; vid.setAttribute("playsinline", ""); vid.preload = "auto"; vid.controls = false;
var po = v.querySelector(".yc-vid__poster"); if (po) vid.poster = po.currentSrc || po.src;
vid.addEventListener("playing", function () { v.classList.add("is-sonando", "is-lista"); });
vid.addEventListener("pause", function () { v.classList.remove("is-sonando"); });
vid.addEventListener("ended", function () { v.classList.remove("is-sonando"); vid.currentTime = 0; });
vid.src = s;
v.insertBefore(vid, v.firstChild);
if (vigiaVid) vigiaVid.observe(v); if (lejosVid) lejosVid.observe(v);
}
track("video_play");
var pr = vid.play(); if (pr && pr.catch) pr.catch(function () { vid.muted = true; vid.play().catch(function () {}); });
}
YC.reproducir = reproducir;
var vivos = hayIO ? new IntersectionObserver(function (es) { es.forEach(function (e) { var b = e.target, v = b.querySelector("video");
if (e.isIntersecting) {
if (document.hidden) return;
if (!v) { v = document.createElement("video"); v.muted = true; v.defaultMuted = true; v.setAttribute("muted", ""); v.loop = true; v.playsInline = true; v.setAttribute("playsinline", ""); v.setAttribute("aria-hidden", "true"); v.preload = "auto";
v.addEventListener("playing", function () { b.classList.add("is-on"); }); v.src = archivo(b.getAttribute("data-yc-loop")); b.appendChild(v); }
var p = v.play(); if (p && p.catch) p.catch(function () {});
} else if (v && !v.paused) v.pause();
}); }, { rootMargin: "100px 0px" }) : null;
function archivo(n) { var m = window.YC_VIDEOS_MAP || {}; return m[n] || (window.YC_VIDEOS ? window.YC_VIDEOS + n : BASE + n); }
function initLoop(b) { if (b.hasAttribute("data-yc-loop-acc")) return; if (vivos && !reducido) vivos.observe(b); }
function initGuia(caja) {
function pintarG() { $$("[data-yc-guia-talla]", caja).forEach(function (b) { var uni = guiaUni != null && est.unis[guiaUni] ? est.unis[guiaUni] : u0(), ok = hayStock(uni.c, b.getAttribute("data-yc-guia-talla")); b.classList.toggle("is-agotada", !ok); atr(b, "aria-disabled", ok ? "false" : "true"); atr(b, "aria-label", "Elegir talla " + b.getAttribute("data-yc-guia-talla") + (ok ? "" : " (agotada en este color)")); }); }
caja.__ycPintar = pintarG; pintarG();
caja.addEventListener("click", function (e) {
var b = e.target.closest ? e.target.closest("[data-yc-guia-talla]") : null; if (!b) return;
var t = b.getAttribute("data-yc-guia-talla"), enGuia = dlgGuia && dlgGuia.contains(caja), uni = enGuia ? guiaUni : null, c = uni != null && est.unis[uni] ? est.unis[uni].c : u0().c;
var nota = $("[data-yc-guia-nota]", caja.parentNode);
if (!hayStock(c, t)) { if (nota) nota.textContent = "La talla " + t + " en " + c + " está agotada. Elige otra talla o cambia de color arriba."; return; }
track("guia_talla_elegida");
if (enGuia) cerrarGuia();
if (uni != null && dlg && dlg.open) { elegirTalla(t, uni, true, "pop"); return; }
elegirTalla(t, 0, true);
setTimeout(function () { if (est.n > 1) { abrirDlg("unidades", null, guiaOrigen); return; } if (accion) { try { accion.scrollIntoView({ behavior: comp, block: "center" }); } catch (e) {} rebotar(ctaMain); } }, enGuia ? 90 : 0);
});
}
function initResenas(sec) {
var b = $("[data-yc-res-mas]", sec), carr = $("[data-yc-res-carr]", sec), liMas = $("[data-yc-res-mas-li]", sec);
function ocultas() { return $$("[data-yc-res-l] > li[hidden]:not([data-yc-res-mas-li])", sec); }
function leer(base) {
$$("[data-yc-res-l] > li:not([hidden]):not([data-yc-res-mas-li])", base || sec).forEach(function (li) {
if (li.__ycLeer) return; var q = $("q", li); if (!q || q.scrollHeight <= q.clientHeight + 2) return; li.__ycLeer = 1;
var bt = document.createElement("button"); bt.type = "button"; bt.className = "yc-res__leer"; bt.textContent = "Leer completa"; bt.setAttribute("aria-expanded", "false");
bt.addEventListener("click", function () { var si = !li.classList.contains("is-abierta"); li.classList.toggle("is-abierta", si); bt.textContent = si ? "Leer menos" : "Leer completa"; bt.setAttribute("aria-expanded", si ? "true" : "false"); });
q.parentNode.insertBefore(bt, q.nextSibling);
});
}
function pintar() { var q = ocultas().length; if (liMas) liMas.hidden = !q; if (b) { var n = $("[data-yc-res-quedan]", b); if (n) n.textContent = q; } }
if (b) b.addEventListener("click", function () {
var nuevas = ocultas().slice(0, 12); nuevas.forEach(function (li) { li.hidden = false; }); pintar(); leer();
if (carr && carr.__refrescar) { carr.__refrescar(); if (nuevas[0] && carr.__irA) carr.__irA(nuevas[0]); }
if (nuevas[0]) { var f = nuevas[0].querySelector("q"); if (f) { nuevas[0].setAttribute("tabindex", "-1"); try { nuevas[0].focus({ preventScroll: true }); } catch (e) {} } }
track("resenas_ver_mas");
});
pintar(); if (carr && carr.__refrescar) carr.__refrescar();
requestAnimationFrame(function () { leer(); });
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { leer(); });
}
function abrirPolitica(a) {
var href = a.getAttribute("href"), d = document.createElement("dialog");
d.className = "yc-dlg yc-dlg-pol"; d.setAttribute("aria-label", a.textContent);
d.innerHTML = '<div class="yc-dlg__in"><div class="yc-dlg__cab"><h2>' + esc(a.textContent) + '</h2><button type="button" class="yc-dlg__x" aria-label="Cerrar">' + ico("cerrar") + '</button></div><div class="yc-dlg__cuerpo"><p>Cargando…</p></div></div>';
raiz.appendChild(d);
$(".yc-dlg__x", d).addEventListener("click", function () { d.close(); });
d.addEventListener("click", function (e) { if (e.target === d) d.close(); });
d.addEventListener("close", function () { if (d.parentNode) d.parentNode.removeChild(d); });
try { d.showModal(); } catch (e) { location.href = href; return; }
fetch(href, { credentials: "same-origin" }).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (h) {
var doc = new DOMParser().parseFromString(h, "text/html"), c = doc.querySelector(".shopify-policy__body, .shopify-policy__container, main") || doc.body;
$$("script,style,iframe,form,link,meta,noscript", c).forEach(function (x) { x.parentNode.removeChild(x); });
$$("*", c).forEach(function (x) { Array.prototype.slice.call(x.attributes).forEach(function (at) { if (/^on/i.test(at.name) || (/^(href|src)$/i.test(at.name) && /^\s*javascript:/i.test(at.value))) x.removeAttribute(at.name); }); });
$$("a[href]", c).forEach(function (x) { var s = document.createElement("span"); s.innerHTML = x.innerHTML; x.parentNode.replaceChild(s, x); });
$(".yc-dlg__cuerpo", d).innerHTML = c.innerHTML.trim() || "<p>Esta política aún no está publicada.</p>";
}).catch(function () { d.close(); location.href = href; });
}
var guiaSrc = raiz.getAttribute("data-yc-guia-src"), guiaP = null, dlgGuia = null, guiaHist = false, guiaOrigen = null, guiaUni = null, ignorarPop = false;
function traerGuia() {
if (!guiaSrc) return Promise.reject(new Error("sin guía"));
if (!guiaP) guiaP = fetch(guiaSrc).then(function (x) { if (!x.ok) throw new Error(x.status); return x.json(); }).then(function (j) {
var t = document.createElement("template"); t.innerHTML = String(j.html).replace(/(^|[\s"'(,])assets\/(?=yc-)/g, "$1" + BASE); return t;
}).catch(function (e) { guiaP = null; throw e; });
return guiaP;
}
YC.traerGuia = traerGuia;
function crearGuia() {
if (dlgGuia) return dlgGuia;
var d = dlgGuia = document.createElement("dialog");
d.className = "yc-dlg yc-dlg-guia"; d.setAttribute("data-yc-guia-dlg", ""); d.setAttribute("aria-labelledby", "yc-guia-t");
d.innerHTML = '<div class="yc-dlg__in"><div class="yc-dlg__cab"><h2 id="yc-guia-t">Encuentra tu talla</h2><button type="button" class="yc-dlg__x" data-yc-guia-cerrar aria-label="Cerrar la guía de tallas">' + ico("cerrar") + '</button></div><div class="yc-dlg__cuerpo" data-yc-guia-cuerpo><p>Cargando la guía de tallas…</p></div></div>';
raiz.appendChild(d); olvidar();
$("[data-yc-guia-cerrar]", d).addEventListener("click", function () { d.close(); });
d.addEventListener("click", function (e) { if (e.target === d) d.close(); });
d.addEventListener("close", function () {
actualizarBarra();
if (guiaHist && history.state && history.state.ycGuia) { guiaHist = false; ignorarPop = true; history.back(); }
guiaHist = false;
if (guiaOrigen && document.contains(guiaOrigen)) try { guiaOrigen.focus({ preventScroll: true }); } catch (e) {}
});
atraparFoco(d);
return d;
}
function abrirGuia(origen, uni) {
crearGuia(); guiaOrigen = origen || document.activeElement; guiaUni = uni == null ? null : uni;
if (!dlgGuia.open) {
try { dlgGuia.showModal(); } catch (e) { dlgGuia.setAttribute("open", ""); }
try { history.pushState({ ycGuia: 1 }, ""); guiaHist = true; } catch (e) {}
track("guia_abierta"); actualizarBarra();
}
var cuerpo = $("[data-yc-guia-cuerpo]", dlgGuia);
if (cuerpo.__ycOk) { var gt = $(".yc-guia__ts", cuerpo); if (gt && gt.__ycPintar) gt.__ycPintar(); return Promise.resolve(); }
return traerGuia().then(function (t) {
if (cuerpo.__ycOk) return; cuerpo.__ycOk = 1;
resolverFotos(t.content); cuerpo.innerHTML = ""; cuerpo.appendChild(t.content.cloneNode(true)); initLote(cuerpo);
cuerpo.scrollTop = 0;
}, function () { cuerpo.innerHTML = "<p>No pudimos abrir la guía de tallas. Revisa tu conexión e intenta de nuevo.</p>"; });
}
function cerrarGuia() { if (dlgGuia && dlgGuia.open) dlgGuia.close(); }
YC.abrirGuia = abrirGuia; YC.cerrarGuia = cerrarGuia;
["pointerenter", "touchstart", "focusin"].forEach(function (ev) {
raiz.addEventListener(ev, function (e) { var t = e.target; if (t && t.closest && t.closest('a[href="#yc-tallas"]')) traerGuia().catch(function () {}); }, { passive: true, capture: true });
});
var mvCargado = false;
var UA = navigator.userAgent || "", ES_IOS = /iPhone|iPad|iPod/i.test(UA) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1), ES_ANDROID = /Android/i.test(UA);
var AR_IOS = !!(CFG.usdz || CFG.arIosSinUsdz), xrOk = null;
function arIntent() {
if (!ES_ANDROID || !CFG.glbAr || xrOk !== false) return "";
var f = "", aqui = location.href.split("#")[0];
try { f = new URL(/^(https?:)?\/\//.test(CFG.glbAr) ? CFG.glbAr : BASE + CFG.glbAr, location.href).href; } catch (e) { return ""; }
return "intent://arvr.google.com/scene-viewer/1.2?mode=ar_preferred&file=" + encodeURIComponent(f) + "&title=" + encodeURIComponent("Blusa Corset · Yass Moda") + "#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=" + encodeURIComponent(aqui) + ";end;";
}
YC.arIntent = arIntent;
function verAR(btn) {
var sec = btn.closest("[data-yc-3d]"), mv = sec && sec.querySelector("model-viewer"), u = arIntent();
track("visor3d_ar");
if (u) { YC.ultimaAR = u; if (!QA) location.href = u; return; }
if (mv && mv.canActivateAR) { YC.ultimaAR = "model-viewer"; try { mv.activateAR(); } catch (e) {} return; }
if (!mv || !mv.loaded) { aviso("La blusa en 3D está cargando. Toca de nuevo en un momento ✨"); return; }
atr(sec, "data-ar", "no"); aviso("Tu celular no permite verla con la cámara. Gírala aquí con el dedo ✨");
}
function init3d(sec) {
if (!CFG.glb) { sec.hidden = true; return; }
atr(sec, "data-ar", ES_IOS ? (AR_IOS ? "si" : "no") : ES_ANDROID ? "si" : "pc");
if (ES_ANDROID && xrOk === null) { try { if (navigator.xr && navigator.xr.isSessionSupported) navigator.xr.isSessionSupported("immersive-ar").then(function (v) { xrOk = !!v; }, function () { xrOk = false; }); else xrOk = false; } catch (e) { xrOk = false; } }
function montar() {
if (!mvCargado) { mvCargado = true; self.ModelViewerElement = self.ModelViewerElement || {}; self.ModelViewerElement.meshoptDecoderLocation = "https://cdn.jsdelivr.net/npm/meshoptimizer@0.21.0/meshopt_decoder.js"; var s = document.createElement("script"); s.type = "module"; s.src = "https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js"; document.head.appendChild(s); }
var caja = $("[data-yc-3d-caja]", sec);
var glb = /^(https?:)?\/\//.test(CFG.glb) ? CFG.glb : (window.YC_VIDEOS_MAP || {})[CFG.glb] || BASE + CFG.glb;
caja.insertAdjacentHTML("beforeend", '<model-viewer src="' + esc(glb) + '"' + (CFG.usdz ? ' ios-src="' + esc(CFG.usdz) + '"' : "") + ' alt="Blusa Corset de Yass Moda en 3D, vista por la espalda" camera-controls touch-action="pan-y" auto-rotate auto-rotate-delay="2500" rotation-per-second="16deg" interaction-prompt="none" environment-image="neutral" tone-mapping="neutral" exposure="1.08" shadow-intensity="0.85" shadow-softness="1" camera-orbit="' + esc(CFG.glbOrbita || "180deg 80deg auto") + '" ar ar-modes="' + (ES_IOS && !AR_IOS ? "webxr scene-viewer" : "webxr scene-viewer quick-look") + '" loading="eager"><span slot="ar-button" hidden></span></model-viewer>');
var mv = $("model-viewer", caja);
function revisarAR() { var puede = !!(mv.canActivateAR || arIntent()); if (ES_IOS && !AR_IOS) puede = false; atr(sec, "data-ar", puede ? "si" : ES_IOS || ES_ANDROID ? "no" : "pc"); }
mv.addEventListener("load", function () { var c = $("[data-yc-3d-cargando]", sec); if (c) c.hidden = true; track("visor3d_cargado"); revisarAR(); setTimeout(revisarAR, 1500); });
mv.addEventListener("camera-change", function (e) { if (e.detail && e.detail.source === "user-interaction" && !mv.__ycGiro) { mv.__ycGiro = 1; track("visor3d_giro"); } });
}
if (!hayIO || QA) { montar(); return; }
var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); montar(); } }, { rootMargin: "600px 0px" }); io.observe(sec);
}
function initBa(box) {
var caja = $("[data-yc-ba-caja]", box), capa = $(".yc-ba__dsp", box), linea = $(".yc-ba__linea", box), mango = $("[data-yc-ba-mango]", box), bts = $$("[data-yc-ba-ir]", box);
if (!caja || !capa || !linea) return;
var p = 0.5, anims = null, raf = 0, toco = false;
function poner(v) {
p = Math.max(0, Math.min(1, v));
if (!anims) { anims = []; try { [[capa, [{ clipPath: "inset(0 0 0 0)" }, { clipPath: "inset(0 0 0 100%)" }]], [linea, [{ left: "0%" }, { left: "100%" }]]].forEach(function (x) { var an = x[0].animate(x[1], { duration: 1000, fill: "both", easing: "linear" }); an.pause(); anims.push(an); }); } catch (x) { anims = []; } }
if (anims.length) anims.forEach(function (a) { try { a.currentTime = Math.min(999.9, p * 1000); } catch (x) {} });
else { capa.style.clipPath = "inset(0 0 0 " + (p * 100).toFixed(1) + "%)"; linea.style.left = (p * 100).toFixed(1) + "%"; }
}
function fijar() {
if (mango) { atr(mango, "aria-valuenow", String(Math.round((1 - p) * 100))); atr(mango, "aria-valuetext", p < 0.35 ? "Se ve sobre todo el cordón ajustado" : p > 0.65 ? "Se ve sobre todo el cordón suelto" : "Mitad y mitad"); }
bts.forEach(function (b) { atr(b, "aria-pressed", (+b.getAttribute("data-yc-ba-ir") === 1 ? p < 0.2 : p > 0.8) ? "true" : "false"); });
}
function ir(dest, ms) {
cancelAnimationFrame(raf);
if (reducido || !ms) { poner(dest); fijar(); return; }
var p0 = p, t0 = performance.now();
(function paso(t) { var k = Math.min(1, (t - t0) / ms), e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2; poner(p0 + (dest - p0) * e); if (k < 1) raf = requestAnimationFrame(paso); else fijar(); })(t0);
}
function usar() { if (!toco) { toco = true; track("antes_despues_toque"); } }
var x0 = null, movio = false, id = null;
function aP(e) { var r = caja.getBoundingClientRect(); return (e.clientX - r.left) / Math.max(1, r.width); }
caja.addEventListener("pointerdown", function (e) { if (e.button) return; x0 = e.clientX; movio = false; id = e.pointerId; cancelAnimationFrame(raf); });
caja.addEventListener("pointermove", function (e) {
if (x0 === null || e.pointerId !== id) return;
if (!movio && Math.abs(e.clientX - x0) < 6) return;
if (!movio) { movio = true; usar(); try { caja.setPointerCapture(id); } catch (x) {} caja.classList.add("is-arrastre"); }
poner(aP(e));
});
function soltar(e) {
if (x0 === null) return; var fue = movio; x0 = null; movio = false; caja.classList.remove("is-arrastre");
if (e.type === "pointercancel") { fijar(); return; }
if (!fue) { usar(); ir(p > 0.5 ? 0.04 : 0.96, 520); } else fijar();
}
caja.addEventListener("pointerup", soltar); caja.addEventListener("pointercancel", soltar);
caja.addEventListener("dragstart", function (e) { e.preventDefault(); });
bts.forEach(function (b) { b.addEventListener("click", function () { usar(); ir(+b.getAttribute("data-yc-ba-ir") === 1 ? 0.04 : 0.96, 520); }); });
if (mango) mango.addEventListener("keydown", function (e) {
var d = e.key === "ArrowLeft" || e.key === "ArrowDown" ? -0.1 : e.key === "ArrowRight" || e.key === "ArrowUp" ? 0.1 : 0;
if (e.key === "Home") { e.preventDefault(); usar(); ir(0.04, 0); return; } if (e.key === "End") { e.preventDefault(); usar(); ir(0.96, 0); return; }
if (!d) return; e.preventDefault(); usar(); poner(p + d); fijar();
});
var pares = $$("[data-yc-ba-par]", box);
pares.forEach(function (b) { b.addEventListener("click", function () { var k = b.getAttribute("data-yc-ba-par"); atr(box, "data-par", k); pares.forEach(function (o) { atr(o, "aria-pressed", o === b ? "true" : "false"); }); usar(); track("antes_despues_" + k); ir(0.5, 0); }); });
poner(0.5); fijar();
if (hayIO && !reducido && !QA) {
var io = new IntersectionObserver(function (es) {
if (!es[0].isIntersecting) return; io.disconnect(); track("antes_despues_visto");
setTimeout(function () { if (toco) return; ir(0.9, 700); setTimeout(function () { if (!toco) ir(0.1, 1100); }, 900); setTimeout(function () { if (!toco) ir(0.5, 700); }, 2300); }, 350);
}, { threshold: 0.6 }); io.observe(caja);
}
box.__ycBa = { ir: ir, pos: function () { return p; } };
}
function pintarDinamicos() {
Q("[data-yc-tono]").forEach(function (b) { atr(b, "aria-pressed", b.getAttribute("data-yc-tono") === u0().c ? "true" : "false"); });
}
var vistas = hayIO ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { vistas.unobserve(e.target); track("seccion_vista_" + e.target.getAttribute("data-yc-lote")); } }); }, { threshold: 0.25 }) : null;
function cada(sel, fn, base) { $$(sel, base).forEach(function (e) { if (e.__ycOk) return; e.__ycOk = 1; fn(e); }); }
function initLote(base) {
olvidar();
resolverFotos(base);
cada("[data-yc-carr]", initCarr, base);
cada(".yc-guia__ts", initGuia, base);
cada("[data-yc-faq], [data-yc-acc]", initAcc, base);
cada("[data-yc-3d]", init3d, base);
cada("[data-yc-ba]", initBa, base);
cada("[data-yc-loop]", initLoop, base);
cada("[data-yc-ver]", initVer, base);
cada(".yc-cta[data-yc-comprar], .yc-cta[data-yc-finalizar]", initCta, base);
cada("#yc-resenas", initResenas, base);
$$("[data-yc-seguidores]", base).forEach(function (e) { if (CFG.seguidores) e.textContent = CFG.seguidores; });
pintarRatings(); pintarPrecios(); pintarDinamicos(); pintarTex();
if (base) { var zl = esContraEntrega() ? "ce" : "linea"; $$("[data-yc-zona]", base).forEach(function (e) { ocultar(e, e.getAttribute("data-yc-zona") !== zl); }); }
}
var ranuras = $$("[data-yc-lote]"), descargas = {}, fallo = 0, arrancado = false, vigia = null;
YC.lotesPedidos = [];
function traerLote(r) {
var n = r.getAttribute("data-yc-lote"), src = r.getAttribute("data-yc-lote-src");
if (!descargas[n] && Date.now() - fallo < 4000) return Promise.reject(new Error("reintento"));
if (!descargas[n]) { YC.lotesPedidos.push(+n); descargas[n] = fetch(src).then(function (x) { if (!x.ok) throw new Error(x.status); return x.json(); }).then(function (j) {
var t = document.createElement("template");
t.innerHTML = String(j.html).replace(/(^|[\s"'(,])assets\/(?=yc-)/g, "$1" + BASE);
return t;
}).catch(function (e) { delete descargas[n]; fallo = Date.now(); throw e; }); }
return descargas[n];
}
var CV = !!(window.CSS && CSS.supports && CSS.supports("content-visibility", "auto"));
function montar(r, t) {
r.classList.add("is-lista");
if (t) {
resolverFotos(t.content); r.appendChild(t.content.cloneNode(true)); initLote(r); if (vistas) vistas.observe(r);
if (CV) { var alto = r.offsetHeight; if (alto > 120) { r.style.containIntrinsicSize = "auto " + alto + "px"; r.classList.add("is-cv"); } }
}
else r.parentNode.removeChild(r);
}
function insertarLote(r) {
if (!r || r.classList.contains("is-lista")) return Promise.resolve();
return traerLote(r).then(function (t) { if (vigia) vigia.unobserve(r); if (!r.classList.contains("is-lista")) montar(r, t); }, function (e) { if (window.console && e.message !== "reintento") console.error("yc lote", e); });
}
function insertarHasta(id) {
var p = Promise.resolve();
for (var i = 0; i < ranuras.length; i++) { (function (r) { p = p.then(function () { return insertarLote(r); }); })(ranuras[i]); if (ranuras[i].getAttribute("data-yc-lote-id") === id) break; }
return p;
}
YC.cargarTodo = function () { return insertarHasta(null); };
function unidadSinTalla() { for (var i = 0; i < est.unis.length; i++) if (!est.unis[i].t) return i; return 0; }
function irA(id) {
if (id === "tallas") { abrirGuia(); return; }
insertarHasta(id).then(function () {
var el = document.getElementById("yc-" + id); if (!el) return;
requestAnimationFrame(function () { el.scrollIntoView({ behavior: comp, block: "start" }); });
[900, 1800].forEach(function (ms) { setTimeout(function () { if (Math.abs(el.getBoundingClientRect().top) > 40) el.scrollIntoView({ block: "start" }); }, ms); });
});
}
function revisarLotes() {
if (ocupado) return;
var r = ranuras.filter(function (x) { return !x.classList.contains("is-lista"); })[0];
if (!r) { if (vigia) vigia.disconnect(); document.removeEventListener("scroll", revisarScroll, true); return; }
var falta = r.getBoundingClientRect().top - innerHeight;
if (falta < 2500) traerLote(r).catch(function () {});
if (falta < 1200) { ocupado = true; insertarLote(r).then(function () { ocupado = false; requestAnimationFrame(revisarLotes); }); }
}
var ocupado = false, revisarScroll = porFrame(revisarLotes);
function arrancarLotes() {
if (arrancado) return; arrancado = true;
if (hayIO) { vigia = new IntersectionObserver(revisarScroll, { rootMargin: "0px 0px 2500px 0px" }); ranuras.forEach(function (r) { vigia.observe(r); }); }
alScroll(revisarScroll);
revisarLotes();
}
function roving(g) {
if (!g) return;
var rs = $$('[role="radio"]', g).filter(function (r) { return !r.disabled && r.getAttribute("aria-disabled") !== "true"; }), c = rs.filter(function (r) { return r.getAttribute("aria-checked") === "true"; })[0] || rs[0];
$$('[role="radio"]', g).forEach(function (r) { var v = r === c ? 0 : -1; if (r.tabIndex !== v || !r.hasAttribute("tabindex")) r.tabIndex = v; });
}
function rovingTodo() { $$('[role="radiogroup"]').forEach(roving); }
function selDe(el) { if (!el || !el.getAttribute) return null; var a = ["data-yc-u", "data-yc-uc", "data-yc-ut", "data-yc-color", "data-yc-talla", "data-yc-n", "data-yc-ciu", "data-yc-regt-t", "data-yc-pn", "data-yc-uni-abrir"], s = ""; a.forEach(function (k) { var v = el.getAttribute(k); if (v != null) s += "[" + k + '="' + String(v).replace(/"/g, '\\"') + '"]'; }); return s || null; }
function conFoco(fn) {
var f = document.activeElement, s = raiz.contains(f) ? selDe(f) : null, cont = f && f.closest ? f.closest("dialog") || raiz : raiz; fn();
if (s && !raiz.contains(f)) { var n = $(s, cont); if (n) try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }
}
raiz.addEventListener("keydown", function (e) {
var t = e.target;
if (t.getAttribute && t.getAttribute("role") === "button" && t.tagName !== "BUTTON" && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); t.click(); return; }
if (!t.getAttribute || t.getAttribute("role") !== "radio") return;
var d = e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : e.key === "ArrowLeft" || e.key === "ArrowUp" ? -1 : 0; if (!d) return;
var g = t.closest('[role="radiogroup"]'); if (!g) return;
var rs = $$('[role="radio"]', g).filter(function (r) { return !r.disabled && r.getAttribute("aria-disabled") !== "true"; }), i = rs.indexOf(t); if (i < 0) return;
e.preventDefault();
var sig = rs[(i + d + rs.length) % rs.length], s = selDe(sig), cont = g.closest("dialog") || raiz;
sig.click();
var n = raiz.contains(sig) ? sig : (s && $(s, cont)) || sig; try { n.focus({ preventScroll: false }); } catch (x) { n.focus(); }
});
raiz.addEventListener("click", function (e) { var r; conFoco(function () { r = alClic(e); }); return r; });
function alClic(e) {
var t = e.target.closest ? e.target : e.target.parentNode, x;
if (dlg && dlg.open && t.closest('[data-yc-dlg] [role="radio"]')) { var er = $("[data-yc-dlg-err]", dlg); if (er && er.firstChild) er.textContent = ""; }
if ((x = t.closest("[data-yc-tallas] [data-yc-talla]"))) { if (x.getAttribute("aria-disabled") === "true") { aviso("La talla " + esc(x.getAttribute("data-yc-talla")) + " está agotada en " + esc(u0().c) + ". Elige otra talla u otro color."); return; } elegirTalla(x.getAttribute("data-yc-talla"), 0, true); return; }
if ((x = t.closest("[data-yc-colores] [data-yc-color]"))) { elegirColor(x.getAttribute("data-yc-color"), 0, true); if (!reducido && !tieneHover) { $$(".yc-color.is-lupa", boxColores).forEach(function (b) { if (b !== x) b.classList.remove("is-lupa"); }); reanimar(x, "is-lupa"); } return; }
if ((x = t.closest("[data-yc-barra-comprar]"))) { comprarBarra(x); return; }
if ((x = t.closest(".yc-regalo"))) { var kr = +x.getAttribute("data-desde"); if (kr > est.n) { track("regalo_toque"); elegirPaquete(kr, $('[data-yc-n="' + kr + '"]', boxPaq)); } return; }
if ((x = t.closest("[data-yc-uc]"))) { elegirColor(x.getAttribute("data-yc-uc"), +x.getAttribute("data-yc-u"), true, "pop"); return; }
if ((x = t.closest("[data-yc-ut]"))) { if (x.getAttribute("aria-disabled") === "true") { var ea = $("[data-yc-dlg-err]", dlg); if (ea) ea.textContent = "Esa talla está agotada en ese color. Elige otra talla u otro color."; return; } elegirTalla(x.getAttribute("data-yc-ut"), +x.getAttribute("data-yc-u"), true, "pop"); return; }
if ((x = t.closest("[data-yc-regt-t]"))) { est.regaloTalla = x.getAttribute("data-yc-regt-t"); est.regaloManual = true; pintarRegaloTalla(); track("popup_regalo_talla"); luego("rov", rovingTodo); return; }
if ((x = t.closest("[data-yc-ciu]"))) { elegirCiudad(x.getAttribute("data-yc-ciu"), true); if (dlg && dlg.contains(x)) track("popup_ciudad"); return; }
if ((x = t.closest("[data-yc-ciu-cambiar]"))) { abrirCambiar(x, x.getAttribute("aria-expanded") !== "true"); return; }
if ((x = t.closest("[data-yc-of-ir]"))) { var ko = +x.getAttribute("data-yc-of-ir"); track(x.hasAttribute("data-yc-ticket") ? "ticket_subir_" + ko : "oferta_atajo"); elegirPaquete(ko, $('[data-yc-n="' + ko + '"]', boxPaq)); return; }
if ((x = t.closest("[data-yc-paq] [data-yc-n]"))) { elegirPaquete(+x.getAttribute("data-yc-n"), x); return; }
if ((x = t.closest("[data-yc-finalizar-ant]"))) { alFinalizarDlg(x, true); return; }
if ((x = t.closest("[data-yc-finalizar]"))) { alFinalizarDlg(x); return; }
if ((x = t.closest("[data-yc-dlg-cerrar]"))) { cerrarDlg(); return; }
if ((x = t.closest("[data-yc-comprar-ant]"))) { comprar(x, true); return; }
if ((x = t.closest("[data-yc-comprar]"))) { comprar(x); return; }
if ((x = t.closest("[data-yc-carrito]"))) { abrirCarrito(); return; }
if ((x = t.closest("[data-yc-3d-ar]"))) { verAR(x); return; }
if ((x = t.closest("[data-yc-tono]"))) { elegirColor(x.getAttribute("data-yc-tono"), 0, true); return; }
if ((x = t.closest(".yc-vid"))) { reproducir(x); return; }
if ((x = t.closest("[aria-controls][aria-expanded]")) && (x.closest("[data-yc-acc]") || x.closest("[data-yc-faq]"))) { var abre = x.getAttribute("aria-expanded") !== "true"; abrirAcc(x, abre); if (abre) { track(x.closest("[data-yc-faq]") ? "faq_abierta" : "detalle_abierto"); if (x.getAttribute("data-yc-acc-ev")) track(x.getAttribute("data-yc-acc-ev")); } return; }
if ((x = t.closest("a[data-yc-pol]"))) { e.preventDefault(); abrirPolitica(x); return; }
if ((x = t.closest('a[href="#yc-tallas"]'))) { e.preventDefault(); var gx = x, gu = dlg && dlg.open && dlg.contains(x) ? unidadSinTalla() : null; if (gu != null) track("popup_guia_vista"); abrirTras(gx, function () { abrirGuia(gx, gu); }); return; }
if ((x = t.closest('a[href^="#yc-"]'))) { e.preventDefault(); irA(x.getAttribute("href").slice(4)); return; }
if ((x = t.closest("[data-yc-gal-pista] .yc-gal__slide"))) { track("foto_toque"); irGal(galAct + 1, true); return; }
if ((x = t.closest("[data-yc-abre]"))) { abrirDetalle(x.getAttribute("data-yc-abre")); return; }
if ((x = t.closest("[data-yc-ir]"))) { irA(x.getAttribute("data-yc-ir")); return; }
if (sinAccionN < 6 && t.closest(".yc-compra") && !t.closest("button,a,input,select,textarea,label,[role=button],[role=radio],dialog")) {
sinAccionN++; track("toque_sin_accion");
var qe = t.closest("[class]"); marcarDato("toque_sin_accion", qe ? String(qe.className).split(" ")[0] : t.tagName);
}
}
var sinAccionN = 0;
function abrirDetalle(id) {
var b = document.getElementById("yc-accb-" + id); if (!b) return;
if (b.getAttribute("aria-expanded") !== "true") { abrirAcc(b, true); track("detalle_abierto"); }
requestAnimationFrame(function () { b.scrollIntoView({ behavior: comp, block: "center" }); });
}
raiz.classList.add("yc-js");
function ligero(motivo) { if (YC.ligero) return; YC.ligero = motivo; raiz.classList.add("yc-ligero"); track("modo_ligero"); marcarDato("ligero", motivo); }
YC.modoLigero = ligero;
if ((navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2) || (navigator.deviceMemory && navigator.deviceMemory <= 2)) ligero("equipo");
else try {
var poLento = new PerformanceObserver(function (l) { l.getEntries().some(function (e) { if (e.interactionId && e.duration >= 200) { poLento.disconnect(); ligero("toque_lento"); return true; } return false; }); });
poLento.observe({ type: "event", durationThreshold: 104 });
} catch (e) {}
if (hayIO) { var ojoAnim = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle("is-quieta", !e.isIntersecting); }); }); $$(".yc-compra, .yc-anuncio").forEach(function (e) { ojoAnim.observe(e); }); }
var armar = function () { raiz.removeEventListener("pointerdown", armar, true); ocio(function () { crearDlg(); pintarPop(); pintarPrecios(); }); };
raiz.addEventListener("pointerdown", armar, { capture: true, passive: true });
saludar();
cada("[data-yc-ver]", initVer);
cada("[data-yc-acc]", initAcc);
cada(".yc-cta[data-yc-comprar]", initCta);
ajustarUnis();
pintarSeleccion();
pintarRatings();
pintarCarrito();
var ciuGuardada = leerSes("yc-ciu"); if (ciuGuardada && CIUS[ciuGuardada]) { elegirCiudad(ciuGuardada, false); ciuManual = true; } else sinCiudad(false);
pintarEntrega();
initReloj();
initBarra();
var hashYj = /^#yc-([\w-]+)/.exec(location.hash);
if (hashYj && hashYj[1] === "tallas") { hashYj = null; abrirGuia(); }
if (QA || !window.fetch) { arrancado = true; YC.cargarTodo(); }
else if (hashYj) { arrancado = true; irA(hashYj[1]); }
else {
var una = function () { ["scroll", "wheel", "touchmove", "keydown"].forEach(function (ev) { document.removeEventListener(ev, una, true); }); arrancarLotes(); };
["scroll", "wheel", "touchmove", "keydown"].forEach(function (ev) { document.addEventListener(ev, una, { passive: true, capture: true }); });
}
window.addEventListener("hashchange", function () { var h = /^#yc-([\w-]+)/.exec(location.hash); if (h) { if (h[1] === "tallas") { abrirGuia(); return; } arrancado = true; irA(h[1]); } });
if (document.readyState === "complete") detectarCiudad(); else window.addEventListener("load", detectarCiudad);
if (!QA) popAutoArrancar();
})();